(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    var url = btn.getAttribute('data-copy-link');
    var label = btn.querySelector('[data-copy-label]');
    var done = function () {
      if (!label) return;
      var prev = label.textContent;
      label.textContent = 'Copied';
      setTimeout(function () {
        label.textContent = prev;
      }, 1600);
    };
    if (navigator.share) {
      navigator.share({ url: url, title: document.title }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () {
        window.prompt('Copy this link', url);
      });
    } else {
      window.prompt('Copy this link', url);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["career"] && !Shopify.designMode) return;
  try {
    
  class CareerJobs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      var button = event.target.closest('.career-job__btn--ghost');
      if (!button || !this.contains(button)) return;

      var panelId = button.getAttribute('aria-controls');
      if (!panelId) return;

      var panel = document.getElementById(panelId);
      if (!panel) return;

      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;

      var label = button.querySelector('.career-job__btn-text');
      if (label) {
        var next = expanded ? button.getAttribute('data-more') : button.getAttribute('data-less');
        if (next) label.textContent = next;
      }
    }
  }

  if (!customElements.get('career-jobs')) {
    customElements.define('career-jobs', CareerJobs);
  }

  /* ---------------- Apply popup ---------------- */
  (function () {
    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function CareerApply(root) {
      this.root = root;
      this.panel = root.querySelector('.career-apply__panel');
      this.roleField = root.querySelector('[data-apply-role]');
      this.opener = null;
      this.bind();
    }

    CareerApply.prototype.bind = function () {
      var self = this;

      // Openers live outside the modal, so they are bound at document level.
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-apply-open]');
        if (!trigger) return;
        if (trigger.getAttribute('aria-controls') !== self.root.id) return;
        event.preventDefault();
        self.open(trigger);
      });

      this.root.addEventListener('click', function (event) {
        if (event.target.closest('[data-apply-close]')) {
          event.preventDefault();
          self.close();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (self.root.getAttribute('aria-hidden') !== 'false') return;
        if (event.key === 'Escape') {
          event.preventDefault();
          self.close();
        } else if (event.key === 'Tab') {
          self.trapFocus(event);
        }
      });

      this.setupUpload();

      // Shopify reloads the page after a contact-form post; reopen so the
      // applicant sees the outcome instead of a silently reset page.
      if (this.root.querySelector('[data-apply-autoopen]')) {
        this.open(null);
      }
    };

    CareerApply.prototype.open = function (trigger) {
      this.opener = trigger;
      this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('data-career-apply-open', '');

      if (trigger && this.roleField) {
        var job = trigger.getAttribute('data-job');
        if (job) this.roleField.value = job;
      }

      var self = this;
      window.setTimeout(function () {
        var first = self.panel.querySelector('input:not([type="hidden"]):not([disabled]), textarea');
        (first || self.panel.querySelector('.career-apply__close')).focus();
      }, 60);
    };

    CareerApply.prototype.close = function () {
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('data-career-apply-open');
      if (this.opener && document.contains(this.opener)) this.opener.focus();
      this.opener = null;
    };

    CareerApply.prototype.trapFocus = function (event) {
      var items = [].slice.call(this.panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el.getAttribute('data-upload-field') !== null;
      });
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    CareerApply.prototype.setupUpload = function () {
      var wrap = this.root.querySelector('[data-upload]');
      if (!wrap) return;

      var zone = wrap.querySelector('[data-upload-zone]');
      var input = wrap.querySelector('[data-upload-field]');
      var idle = wrap.querySelector('[data-upload-idle]');
      var picked = wrap.querySelector('[data-upload-picked]');
      var nameOut = wrap.querySelector('[data-upload-name]');
      var remove = wrap.querySelector('[data-upload-remove]');
      var error = wrap.querySelector('[data-upload-error]');
      if (!zone || !input) return;

      var maxMb = parseFloat(input.getAttribute('data-max-mb')) || 5;
      var accept = (input.getAttribute('accept') || '')
        .split(',')
        .map(function (x) {
          return x.trim().toLowerCase().replace(/^\./, '');
        })
        .filter(Boolean);

      function fail(message) {
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
        zone.classList.add('is-invalid');
        input.value = '';
        show(false);
      }

      function clearError() {
        if (error) {
          error.textContent = '';
          error.hidden = true;
        }
        zone.classList.remove('is-invalid');
      }

      function show(hasFile) {
        if (idle) idle.hidden = hasFile;
        if (picked) picked.hidden = !hasFile;
      }

      function accepted(file) {
        clearError();

        var ext = file.name.split('.').pop().toLowerCase();
        if (accept.length && accept.indexOf(ext) === -1) {
          fail('That file type is not allowed. Please upload ' + accept.join(', ') + '.');
          return false;
        }
        if (file.size > maxMb * 1024 * 1024) {
          fail('That file is too large. The limit is ' + maxMb + 'MB.');
          return false;
        }
        if (nameOut) nameOut.textContent = file.name;
        show(true);
        return true;
      }

      input.addEventListener('change', function () {
        if (input.files && input.files.length) {
          accepted(input.files[0]);
        } else {
          clearError();
          show(false);
        }
      });

      if (remove) {
        remove.addEventListener('click', function () {
          input.value = '';
          clearError();
          show(false);
          input.focus();
        });
      }

      ['dragenter', 'dragover'].forEach(function (type) {
        zone.addEventListener(type, function (event) {
          event.preventDefault();
          zone.classList.add('is-dragging');
        });
      });

      ['dragleave', 'dragend'].forEach(function (type) {
        zone.addEventListener(type, function () {
          zone.classList.remove('is-dragging');
        });
      });

      zone.addEventListener('drop', function (event) {
        event.preventDefault();
        zone.classList.remove('is-dragging');

        var files = event.dataTransfer && event.dataTransfer.files;
        if (!files || !files.length) return;

        if (accepted(files[0])) {
          try {
            input.files = files;
          } catch (e) {
            // Older browsers block assigning FileList; ask for the picker instead.
            fail('Your browser cannot accept dropped files. Please use Browse file.');
          }
        }
      });
    };

    function init(scope) {
      var nodes = (scope || document).querySelectorAll('[data-career-apply]');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].dataset.applyReady) continue;
        nodes[i].dataset.applyReady = 'true';
        new CareerApply(nodes[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    // Theme editor re-renders sections without a page load.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const remove = e.target.closest('[data-remove]');
        if (remove) {
          e.preventDefault();
          const row = remove.closest('[data-line]');
          row.classList.add('is-loading');
          this.changeLine(row.dataset.line, 0);
          return;
        }
        const minus = e.target.closest('[data-qty-minus]');
        const plus = e.target.closest('[data-qty-plus]');
        if (minus || plus) {
          const row = e.target.closest('[data-line]');
          const stepper = row.querySelector('[data-qty]');
          const qtyEl = row.querySelector('.cart-item__qty-value');
          const current = parseInt(qtyEl.textContent, 10) || 1;
          const next = plus ? current + 1 : current - 1;
          if (stepper) stepper.classList.add('is-loading');
          if (next <= 0) row.classList.add('is-loading');
          this.changeLine(row.dataset.line, Math.max(0, next));
        }
      });

      // Discount code: Shopify applies codes through /discount/CODE and bounces back.
      this.addEventListener('submit', (e) => {
        const form = e.target.closest('[data-discount-form]');
        if (!form) return;
        e.preventDefault();
        const input = form.querySelector('input[name="discount"]');
        const code = input && input.value.trim();
        if (!code) {
          if (input) input.focus();
          return;
        }
        const btn = form.querySelector('button');
        if (btn) btn.classList.add('is-loading');
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
    }

    get items() {
      return this.querySelector('[data-cart-items]');
    }

    setBusy(state) {
      const items = this.items;
      if (window.Jogger && Jogger.setBusy) Jogger.setBusy(items, state);
      else if (items) items.classList.toggle('is-busy', state);
    }

    changeLine(line, quantity) {
      this.setBusy(true);
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity }),
      })
        .then((r) => {
          if (!r.ok) throw new Error('change failed');
          return r.json();
        })
        .then((cart) => {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
          return this.rerender();
        })
        .catch(() => window.location.reload())
        .finally(() => this.setBusy(false));
    }

    rerender() {
      const id = this.dataset.sectionId;
      return fetch(window.location.pathname + '?section_id=' + id)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('cart-page');
          if (fresh) {
            this.innerHTML = fresh.innerHTML;
            if (window.Jogger) {
              Jogger.prepImages(this);
              Jogger.observeLazy(this);
            }
          }
        });
    }
  }
  if (!customElements.get('cart-page')) customElements.define('cart-page', CartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id') || '';
      this.drawer = this.querySelector('#FilterDrawer');

      try {
        this.infiniteScroll();
      } catch (e) {
        /* the Load more link still works by tap */
      }

      try {
        this.stickySidebar();
      } catch (e) {
        /* never let the sidebar break filtering */
      }

      try {
        this.watchFilterApp();
      } catch (e) {
        /* leave the theme filters in place if detection fails */
      }

      try {
        this.appCardHover();
      } catch (e) {
        /* a card that does not swap is a nuisance, not a broken page */
      }

      try {
        this.appBusyFallback();
      } catch (e) {
        /* a grid that does not dim while the app filters is cosmetic */
      }

      try {
        this.filterFab();
      } catch (e) {
        /* the in-page Filter button still works */
      }

      try {
        this.appColourCards();
      } catch (e) {
        /* cards keep their default photo */
      }

      this.bindNative();
    }

    /* ---- Filter app's cards in the chosen colour ----
       The app draws its cards from its own data and only follows variant
       filters it recognises, so with a colour filter (e.g. the category
       Color field) a product with a Red variant still showed its default
       photo. Here: read the active colour(s) from the URL, look up each
       card's product (/products/<handle>.js, cached), find the variant in
       that colour (by option value, ignoring case, spaces and dots) and
       switch the card's photo and link to it. Without a colour filter the
       cards are put back exactly as the app drew them. */
    appColourCards() {
      var host = this;
      var map = {};
      var mapEl = this.querySelector('[data-colour-map]');
      if (mapEl) {
        try {
          map = JSON.parse(mapEl.textContent) || {};
        } catch (e) {
          map = {};
        }
      }
      var cache = {};

      function norm(v) {
        return String(v == null ? '' : v).toLowerCase().replace(/[\s.\-_\/]+/g, '');
      }

      function activeColours() {
        var out = [];
        var params = new URLSearchParams(window.location.search);
        params.forEach(function (value, key) {
          if (!/colou?r/i.test(key)) return;
          var label = map[value] || value;
          var n = norm(label);
          if (n && out.indexOf(n) === -1) out.push(n);
        });
        return out;
      }

      function productJson(handle) {
        if (!cache[handle]) {
          var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          cache[handle] = fetch(base + 'products/' + handle + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .catch(function () {
              return null;
            });
        }
        return cache[handle];
      }

      function findVariant(product, colours) {
        if (!product || !product.variants) return null;
        var loose = null;
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var opts = (v.options || []).map(norm);
          for (var c = 0; c < colours.length; c++) {
            if (opts.indexOf(colours[c]) !== -1) return v;
            if (!loose) {
              for (var o = 0; o < opts.length; o++) {
                if (opts[o] && (opts[o].indexOf(colours[c]) !== -1 || colours[c].indexOf(opts[o]) !== -1)) {
                  loose = v;
                  break;
                }
              }
            }
          }
        }
        return loose;
      }

      function sized(src) {
        if (!src) return src;
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=720';
      }

      function cards() {
        return document.querySelectorAll(
          '.jogger-spf-col .product-card, #gf-products .product-card, #gf-grid .product-card, collection-page .collection-page__grid .product-card'
        );
      }

      function restore(card) {
        if (!card.classList.contains('is-colour-match')) return;
        var link = card.querySelector('a[href*="/products/"]');
        var img = card.querySelector('.product-card__img--main, .spf-product-card__image-main') || card.querySelector('.product-card__img:not(.product-card__img--hover)');
        if (link && link.dataset.origHref) link.setAttribute('href', link.dataset.origHref);
        if (img && img.dataset.origSrc) {
          img.setAttribute('src', img.dataset.origSrc);
          if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
        }
        card.classList.remove('is-colour-match');
      }

      function apply(card, colours) {
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        var href = link.dataset.origHref || link.getAttribute('href');
        var m = href.match(/\/products\/([^/?#]+)/);
        if (!m) return;
        var key = colours.join('|');
        if (card.dataset.colourKey === key) return;
        card.dataset.colourKey = key;
        productJson(m[1]).then(function (product) {
          if (card.dataset.colourKey !== key) return;
          var v = findVariant(product, colours);
          if (!v) {
            restore(card);
            return;
          }
          if (!link.dataset.origHref) link.dataset.origHref = href;
          var base = href.split('?')[0];
          var url = base + '?variant=' + v.id;
          card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
            if (!a.dataset.origHref) a.dataset.origHref = a.getAttribute('href');
            a.setAttribute('href', url);
          });
          var src = v.featured_image && (v.featured_image.src || v.featured_image);
          // No photo on the variant: a product photo whose alt text names the colour
          if (!src && product.media) {
            for (var q = 0; q < product.media.length && !src; q++) {
              var alt = norm(product.media[q].alt);
              for (var cc = 0; cc < colours.length; cc++) {
                if (alt && alt.indexOf(colours[cc]) !== -1 && product.media[q].src) {
                  src = product.media[q].src;
                  break;
                }
              }
            }
          }
          var img = card.querySelector('.product-card__img--main, .spf-product-card__image-main') || card.querySelector('.product-card__img:not(.product-card__img--hover)');
          if (img && src && typeof src === 'string') {
            if (!img.dataset.origSrc) {
              img.dataset.origSrc = img.getAttribute('src') || '';
              img.dataset.origSrcset = img.getAttribute('srcset') || '';
            }
            img.removeAttribute('srcset');
            img.setAttribute('data-src', sized(src));
            img.setAttribute('src', sized(src));
          }
          card.classList.add('is-colour-match');
        });
      }

      var timer = null;
      function run() {
        var colours = activeColours();
        var list = cards();
        for (var i = 0; i < list.length; i++) {
          if (!colours.length) {
            list[i].dataset.colourKey = '';
            restore(list[i]);
          } else {
            apply(list[i], colours);
          }
        }
      }
      function queue() {
        clearTimeout(timer);
        timer = setTimeout(run, 150);
      }

      run();
      window.addEventListener('popstate', queue);
      ['pushState', 'replaceState'].forEach(function (fn) {
        var orig = history[fn];
        if (!orig || orig.__joggerColour) return;
        var wrapped = function () {
          var r = orig.apply(this, arguments);
          queue();
          return r;
        };
        wrapped.__joggerColour = true;
        history[fn] = wrapped;
      });
      if (window.MutationObserver) {
        new MutationObserver(function (list) {
          for (var i = 0; i < list.length; i++) {
            if (list[i].addedNodes && list[i].addedNodes.length) {
              queue();
              return;
            }
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
    }

    /* ---- Floating Filter button (phones) ----
       Shows once the page is scrolled down. Opens the theme drawer, or — when
       the filter app is live — taps the app's own Filter toggle. The app's
       toggle is also un-stuck, so it no longer parks at the top of the
       screen over the products. */
    filterFab() {
      var host = this;
      var fab = this.querySelector('[data-filter-fab]');
      if (!fab) return;

      function isAppLive() {
        return host.classList.contains('app-live') || host.getAttribute('data-filter-source') === 'app';
      }

      // The app's mobile Filter toggle: a visible control in its markup whose text is "Filter…"
      var cachedToggle = null;
      function appToggle() {
        if (cachedToggle && cachedToggle.isConnected) return cachedToggle;
        cachedToggle = findAppToggle();
        return cachedToggle;
      }
      function findAppToggle() {
        var nodes = document.querySelectorAll(
          '[id^="gf-"] button, [id^="gf-"] a, [id^="gf-"] [role="button"], [class*="gf-"] button, [class*="gf-"] a, [class*="gf-refine"], [class*="gf-filter-btn"], [class*="spf"] button, [class*="gspf"] button'
        );
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n === fab || host.contains(n) && n.closest('[data-filter-fab]')) continue;
          var txt = (n.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (txt.indexOf('filter') === 0 && txt.length < 30) return n;
        }
        return null;
      }

      // Phones: the app's own Filter bar at the top is hidden — the floating
      // button replaces it. Hides the toggle plus any wrapper around it that
      // holds nothing else (the full-width bar), never a wrapper with other
      // content. It stays in the page, so the floating button can still tap it.
      var hiddenBar = null;
      function hideAppBar() {
        if (hiddenBar && hiddenBar.isConnected) return;
        var t = appToggle();
        if (!t) return;
        var label = (t.textContent || '').replace(/\s+/g, ' ').trim();
        var bar = t;
        var node = t.parentElement;
        for (var i = 0; i < 4 && node && node !== document.body && node !== host; i++) {
          var txt = (node.textContent || '').replace(/\s+/g, ' ').trim();
          if (txt !== label || node.offsetHeight > 120) break;
          bar = node;
          node = node.parentElement;
        }
        bar.classList.add('jogger-app-filterbar');
        hiddenBar = bar;
      }

      fab.addEventListener('click', function (e) {
        e.preventDefault();
        if (isAppLive()) {
          var t = appToggle();
          if (t) {
            t.click();
            return;
          }
        }
        if (host.drawer) host.toggle(true);
      });

      var ticking = false;
      function update() {
        ticking = false;
        if (window.innerWidth >= 990) {
          fab.classList.remove('is-visible');
          return;
        }
        if (isAppLive()) hideAppBar();
        fab.classList.toggle('is-visible', gridOnScreen());
      }

      // The product grid in use: the app's when it is live, else the theme's
      function productGrid() {
        if (isAppLive()) {
          var app = document.querySelector('#gf-products, #gf-grid, [id^="gf-grid"], .gf-grid, .spf-row');
          if (app && app.getClientRects().length) return app;
        }
        return host.querySelector('.collection-page__grid') || host.querySelector('.collection-page__layout');
      }

      // Shown only while the products fill part of the screen — hidden over the
      // banner above them and the footer below them
      function gridOnScreen() {
        var grid = productGrid();
        if (!grid) return false;
        var r = grid.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        return r.top < vh * 0.6 && r.bottom > vh * 0.5;
      }
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
      // The app draws its bar after load: keep looking for a few seconds
      var tries = 0;
      var timer = setInterval(function () {
        update();
        if (++tries > 20 || (hiddenBar && hiddenBar.isConnected)) clearInterval(timer);
      }, 500);
    }

    /* ---- Theme filtering, sorting and paging ----
       Everything inside the main column is replaced on refresh, so the
       listeners are delegated from the host rather than bound to elements. */
    bindNative() {
      var host = this;

      this.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;

        if (t.closest('[data-filter-open]') && host.drawer) {
          e.preventDefault();
          host.toggle(true);
          return;
        }
        if (t.closest('[data-filter-close]') && host.drawer) {
          e.preventDefault();
          host.toggle(false);
          return;
        }
        var chip = t.closest('[data-chip-remove]');
        if (chip && chip.getAttribute('href')) {
          e.preventDefault();
          if (host.drawer && host.drawer.contains(chip)) host.toggle(false);
          host.navigate(chip.getAttribute('href'));
          return;
        }
        var page = t.closest('.collection-page__pagination a[href]');
        if (page) {
          e.preventDefault();
          host.navigate(page.getAttribute('href'), { scroll: true });
          return;
        }
        var more = t.closest('[data-load-more]');
        if (more) {
          e.preventDefault();
          host.loadMore(more);
        }
      });

      this.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.matches) return;

        if (t.matches('[data-sort-select]')) {
          var label = host.querySelector('[data-sort-value]');
          if (label && t.selectedIndex >= 0) label.textContent = t.options[t.selectedIndex].text;
          var params = new URLSearchParams(window.location.search);
          params.set('sort_by', t.value);
          params.delete('page');
          host.applyParams(params);
          return;
        }
        // Drawer: keep the "Show N results" button honest while ticking
        if (host.drawer && host.drawer.contains(t) && t.name) host.previewCount();
      });

      this.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('[data-facets-form]')) return;
        e.preventDefault();
        if (host.drawer && host.drawer.contains(form)) host.toggle(false);
        host.applyParams(host.collectParams(form));
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && host.drawer && host.drawer.getAttribute('aria-hidden') === 'false') host.toggle(false);
      });

      window.addEventListener('popstate', function () {
        if (!host.canRefresh()) return;
        host.refresh(window.location.href, { push: false });
      });
    }

    collectParams(scope) {
      var params = new URLSearchParams();
      var fields = scope.querySelectorAll('input[name], select[name]');
      for (var i = 0; i < fields.length; i++) {
        var el = fields[i];
        if (el.disabled) continue;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
        var v = el.value == null ? '' : String(el.value).trim();
        if (v === '') continue;
        params.append(el.name, v);
      }
      return params;
    }

    /* Public: the facets snippet hands the sidebar's params here. The sidebar
       carries no sort control, so the current sort is kept across a filter. */
    applyParams(params) {
      var base = window.location.pathname;
      if (!params.has('sort_by')) {
        var current = new URLSearchParams(window.location.search).get('sort_by');
        if (current) params.set('sort_by', current);
      }
      var qs = params.toString();
      this.navigate(qs ? base + '?' + qs : base);
    }

    canRefresh() {
      return !!(this.sectionId && window.fetch && window.DOMParser && window.history && history.pushState);
    }

    navigate(url, opts) {
      var a = document.createElement('a');
      a.href = url;
      // Only this collection can be refreshed in place; anything else
      // (another collection, "Browse all") is an ordinary navigation.
      if (!this.canRefresh() || a.pathname !== window.location.pathname) {
        document.body.classList.add('is-filtering');
        window.location.href = url;
        return;
      }
      this.refresh(a.href, Object.assign({ push: true }, opts || {}));
    }

    sectionUrl(url) {
      try {
        var u = new URL(url, window.location.href);
        u.searchParams.set('section_id', this.sectionId);
        u.hash = '';
        return u.toString();
      } catch (e) {
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(this.sectionId);
      }
    }

    refresh(url, opts) {
      var host = this;
      opts = opts || {};
      var main = this.querySelector('[data-collection-main]');
      var grid = this.querySelector('.collection-page__grid');
      if (!main) {
        window.location.href = url;
        return;
      }
      var J = window.Jogger;
      if (J && J.setBusy) J.setBusy(grid, true);
      var token = (this.refreshToken = (this.refreshToken || 0) + 1);

      fetch(this.sectionUrl(url), { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        })
        .then(function (html) {
          if (token !== host.refreshToken) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('collection-page');
          var freshMain = fresh && fresh.querySelector('[data-collection-main]');
          if (!freshMain) throw new Error('section missing');

          main.innerHTML = freshMain.innerHTML;
          host.swapFacets(fresh);
          host.syncCounts(fresh);
          if (opts.push !== false) history.pushState({ joggerCollection: true }, '', url);
          if (J) {
            if (J.prepImages) J.prepImages(main);
            if (J.observeLazy) J.observeLazy(main);
          }
          if (opts.scroll) host.scrollToTop();
          document.body.classList.remove('is-filtering');
        })
        .catch(function () {
          if (token !== host.refreshToken) return;
          window.location.href = url;
        });
    }

    /* Sidebar + drawer facets are re-rendered with fresh counts and disabled
       states, keeping each group's open state and the control that had focus. */
    swapFacets(fresh) {
      var active = document.activeElement;
      var focusKey = null;
      if (active && active.name && this.contains(active)) {
        focusKey = { name: active.name, value: active.value, type: active.type };
      }
      var boxes = this.querySelectorAll('[data-facets]');
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        var key = box.getAttribute('data-facets');
        var next = fresh.querySelector('[data-facets="' + key + '"]');
        if (!next) continue;
        var open = [];
        var groups = box.querySelectorAll('details.facet');
        for (var g = 0; g < groups.length; g++) if (groups[g].open) open.push(g);
        box.innerHTML = next.innerHTML;
        var fresher = box.querySelectorAll('details.facet');
        for (var h = 0; h < fresher.length; h++) fresher[h].open = open.indexOf(h) !== -1;
        // Lets the facets snippet re-sync its price slider thumbs
        if (typeof CustomEvent === 'function') box.dispatchEvent(new CustomEvent('jogger:facets-updated', { bubbles: true }));
      }
      if (focusKey) {
        var fields = this.querySelectorAll('[name]');
        for (var f = 0; f < fields.length; f++) {
          var el = fields[f];
          if (el.name !== focusKey.name) continue;
          if (focusKey.type === 'checkbox' || focusKey.type === 'radio') {
            if (el.value !== focusKey.value) continue;
          }
          if (el.focus) el.focus({ preventScroll: true });
          break;
        }
      }
    }

    syncCounts(fresh) {
      var src = fresh.querySelector('[data-results-count]');
      var count = src ? src.textContent.trim() : null;
      if (count !== null) {
        var targets = this.querySelectorAll('[data-results-count]');
        for (var i = 0; i < targets.length; i++) targets[i].textContent = count;
      }
    }

    scrollToTop() {
      var layout = this.querySelector('.collection-page__layout') || this;
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var top = layout.getBoundingClientRect().top + window.pageYOffset - header - 8;
      if (layout.getBoundingClientRect().top < header) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    /* Drawer: fetch the would-be result count for the current selection and
       print it on the apply button. */
    previewCount() {
      var host = this;
      var form = this.drawer && this.drawer.querySelector('[data-facets-form]');
      var btn = this.drawer && this.drawer.querySelector('[data-filter-apply]');
      if (!form || !btn || !this.canRefresh()) return;
      clearTimeout(this.previewTimer);
      this.previewTimer = setTimeout(function () {
        var params = host.collectParams(form);
        var qs = params.toString();
        var url = window.location.pathname + (qs ? '?' + qs : '');
        var token = (host.previewToken = (host.previewToken || 0) + 1);
        btn.classList.add('is-loading');
        fetch(host.sectionUrl(url), { headers: { Accept: 'text/html' } })
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .then(function (html) {
            if (token !== host.previewToken) return;
            btn.classList.remove('is-loading');
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.querySelector('[data-results-count]');
            var out = btn.querySelector('[data-results-count]');
            if (src && out) out.textContent = src.textContent.trim();
          })
          .catch(function () {
            btn.classList.remove('is-loading');
          });
      }, 350);
    }

    /* Auto-load on scroll: when the "loading more" row comes within
       ~600px of the viewport, the next page is fetched (same path as the
       Load more button). Re-armed after every load and every filter
       refresh, since both replace the row. Stops by itself on the last page
       (no next link is rendered), and never fires twice at once. */
    infiniteScroll() {
      if (!this.hasAttribute('data-infinite-scroll')) return;
      if (!('IntersectionObserver' in window) || !this.canRefresh()) return;
      var host = this;
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            var btn = entries[i].target;
            if (!btn.isConnected) { io.unobserve(btn); continue; }
            io.unobserve(btn);
            host.loadMore(btn);
          }
        },
        { rootMargin: '0px 0px 600px 0px', threshold: 0 }
      );
      var arm = function () {
        var btn = host.querySelector('[data-load-more][data-auto-load]');
        if (btn && !btn.dataset.autoArmed) {
          btn.dataset.autoArmed = '1';
          io.observe(btn);
        }
      };
      arm();
      // Any swap of the load-more row (next page, filter/sort refresh) re-arms
      if ('MutationObserver' in window) {
        var pending = 0;
        new MutationObserver(function () {
          if (pending) return;
          pending = window.requestAnimationFrame(function () { pending = 0; arm(); });
        }).observe(this, { childList: true, subtree: true });
      }
    }

    /* "Load more": skeleton cards fill the next row while the page is
       fetched, then the real cards take their place. */
    loadMore(btn) {
      var host = this;
      var url = btn.getAttribute('href') || btn.getAttribute('data-next-url');
      var grid = this.querySelector('.collection-page__grid');
      var wrap = btn.closest('[data-load-more-wrap]');
      if (!url || !grid || btn.classList.contains('is-loading')) return;
      if (!this.canRefresh()) {
        window.location.href = url;
        return;
      }
      var J = window.Jogger;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');

      var count = parseInt(btn.getAttribute('data-next-count'), 10);
      if (!(count > 0)) count = 4;
      var ph = document.createElement('div');
      ph.className = 'collection-page__skeletons';
      ph.setAttribute('aria-hidden', 'true');
      ph.innerHTML = J && J.skeletonCards ? J.skeletonCards(Math.min(count, 12)) : '';
      grid.appendChild(ph);

      fetch(this.sectionUrl(url), { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('collection-page');
          var freshGrid = fresh && fresh.querySelector('.collection-page__grid');
          if (!freshGrid) throw new Error('grid missing');

          var frag = document.createDocumentFragment();
          var first = null;
          var kids = Array.prototype.slice.call(freshGrid.children);
          for (var i = 0; i < kids.length; i++) {
            if (kids[i].classList.contains('collection-page__empty')) continue;
            if (!first) first = kids[i];
            frag.appendChild(kids[i]);
          }
          ph.remove();
          grid.appendChild(frag);

          var freshWrap = fresh.querySelector('[data-load-more-wrap]');
          if (wrap) {
            if (freshWrap) wrap.replaceWith(freshWrap);
            else wrap.remove();
          }
          if (J) {
            if (J.prepImages) J.prepImages(grid);
            if (J.observeLazy) J.observeLazy(grid);
          }
          try {
            history.replaceState({ joggerCollection: true }, '', url);
          } catch (e) {
            /* URL bookkeeping only */
          }
          var focusEl = first && first.querySelector('a, button');
          if (focusEl && focusEl.focus) focusEl.focus({ preventScroll: true });
        })
        .catch(function () {
          ph.remove();
          window.location.href = url;
        });
    }

    toggle(open) {
      if (!this.drawer) return;
      var btn = this.querySelector('[data-filter-open]');
      this.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('filter-open', open);
      if (open) {
        var close = this.drawer.querySelector('button[data-filter-close]');
        if (close && close.focus) close.focus();
      } else if (btn && btn.focus) {
        btn.focus();
      }
    }

    /* ---- Filter app: dim the grid while it works ----
       Globo filters without the theme fetching anything, so there is no
       request to hook. Instead: a tap on one of its options marks the grid
       busy, and the first change to the grid (or 4s, whichever is first)
       clears it. */
    appBusyFallback() {
      if (this.getAttribute('data-filter-source') === 'native') return;
      var host = this;
      var observer = null;
      var timer = null;
      var busyGrid = null;

      // Looked up late: the shared script is deferred and may land after this
      function J() {
        return window.Jogger && window.Jogger.setBusy ? window.Jogger : null;
      }
      function grid() {
        return (
          document.querySelector('#gf-products') ||
          document.querySelector('.jogger-spf-row') ||
          host.querySelector('.collection-page__grid')
        );
      }
      function clear() {
        if (observer) observer.disconnect();
        observer = null;
        clearTimeout(timer);
        if (busyGrid && J()) J().setBusy(busyGrid, false);
        busyGrid = null;
      }
      function start() {
        var g = grid();
        if (!g || !J()) return;
        clear();
        busyGrid = g;
        J().setBusy(g, true);
        if ('MutationObserver' in window) {
          observer = new MutationObserver(clear);
          observer.observe(g, { childList: true, subtree: true });
        }
        timer = setTimeout(clear, 4000);
      }
      function inTree(el) {
        return !!(el && el.closest && el.closest('#gf-tree, .gf-tree, #gspf-filter-tree, .gspf-filter-tree, .globo-selected-items-wrapper'));
      }

      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !inTree(t)) return;
        if (!/^(INPUT|SELECT)$/.test(t.nodeName)) return;
        start();
      });
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var opt = t.closest('.gf-option-block ul li a, .gf-option-block ul li button, .gf-clear, .gf-clear-all, .selected-item a');
        if (!opt || !inTree(opt)) return;
        start();
      });
    }

    /* ---- Prices on app-rendered cards ----
       Shopify stores prices in cents, but the filter app hands its template
       the amount already in currency units ("7.00"). Treating that as cents
       divided it by 100 a second time, which is where ₹0.07 came from. The
       shape of the value tells us which it is: a decimal point means units,
       a bare integer means cents. */
    amountToUnits(raw) {
      var str = String(raw == null ? '' : raw).trim().replace(/[^0-9.\-]/g, '');
      if (!str) return null;

      // A decimal point settles it: the value is already in currency units.
      if (str.indexOf('.') !== -1) {
        var d = parseFloat(str);
        return isFinite(d) && d >= 0 ? d : null;
      }

      // A bare integer is ambiguous — 699 could be ₹6.99 in cents or ₹699 in
      // units, and guessing wrong is how ₹699 became ₹6.99. The collection's
      // own price range decides it: whichever reading lands inside the prices
      // this page actually contains is the right one.
      var n = parseInt(str, 10);
      if (!isFinite(n) || n < 0) return null;

      var min = parseInt(this.getAttribute('data-price-min'), 10);
      var max = parseInt(this.getAttribute('data-price-max'), 10);
      var asCents = n;
      var asUnits = n * 100;

      if (isFinite(min) && isFinite(max) && max > 0) {
        var lo = min * 0.5;
        var hi = max * 2;
        var centsFits = asCents >= lo && asCents <= hi;
        var unitsFits = asUnits >= lo && asUnits <= hi;
        if (centsFits && !unitsFits) return asCents / 100;
        if (unitsFits && !centsFits) return asUnits / 100;
      }

      // No usable range: a price under ₹100 in cents is implausible for this
      // catalogue, so a small integer is read as whole rupees.
      return asCents >= 1000 ? asCents / 100 : n;
    }

    /* Indian grouping: 1,234.00 and 1,23,456.00 */
    formatRupees(raw) {
      var units = this.amountToUnits(raw);
      if (units === null) return null;
      var whole = Math.floor(units);
      var paise = Math.round((units - whole) * 100);
      if (paise === 100) {
        whole += 1;
        paise = 0;
      }
      var digits = String(whole);
      var grouped = digits;
      if (digits.length > 3) {
        var last3 = digits.slice(-3);
        var head = digits.slice(0, digits.length - 3);
        var parts = '';
        while (head.length > 2) {
          parts = head.slice(-2) + ',' + parts;
          head = head.slice(0, head.length - 2);
        }
        grouped = head + ',' + parts + last3;
      }
      return grouped + '.' + (paise < 10 ? '0' + paise : String(paise));
    }

    repriceAppCards() {
      // Only rupee prices are reformatted. When a market is presenting another
      // currency the app's own formatting is already right for it, and a rupee
      // mark would be a lie about what the shopper is charged.
      var currency = this.getAttribute('data-currency') || '';
      if (currency !== 'INR') return;

      var els = document.querySelectorAll('[data-price-cents]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.getAttribute('data-repriced') === '1') continue;
        var value = this.formatRupees(el.getAttribute('data-price-cents'));
        if (value === null) continue;
        var svg = el.querySelector('svg');
        el.textContent = value;
        if (svg) el.insertBefore(svg, el.firstChild);
        el.setAttribute('data-repriced', '1');
      }
    }

    /* ---- Hover swap on the filter app's cards ----
       The markup is right and the CSS is right, but the app's own stylesheet
       loads in an unpredictable order and still sets its own opacity and
       display on .spf-product-card__image-secondary. Rather than keep raising
       specificity against it, the swap is driven from here: an inline style
       set with priority outranks every rule in every stylesheet, whichever
       loaded last. The CSS remains the resting state; this is the enforcer.

       Delegated from the document so cards the app re-renders after every
       filter change are covered without rebinding anything. */
    appCardHover() {
      var host = this;
      var CARD = '.jogger-spf-col .product-card';
      var MAIN = '.product-card__img--main, .spf-product-card__image-main';
      var HOVER = '.product-card__img--hover, .spf-product-card__image-secondary';

      var canHover = true;
      if (window.matchMedia) {
        canHover = window.matchMedia('(hover: hover)').matches;
      }

      function force(el, prop, value) {
        if (el && el.style) el.style.setProperty(prop, value, 'important');
      }

      /* Geometry and stacking, not just visibility.
         An image can be fully opaque and still invisible: if the app gives the
         main photo a higher z-index, or un-sizes or shifts the second one, the
         swap measures perfectly and shows nothing. Both photos are pinned to
         the same box here and the hover one is put on top, so what is painted
         is decided by this and not by whichever stylesheet loaded last. */
      function pin(el, z) {
        if (!el || !el.style) return;
        force(el, 'position', 'absolute');
        force(el, 'top', '0');
        force(el, 'right', '0');
        force(el, 'bottom', '0');
        force(el, 'left', '0');
        force(el, 'width', '100%');
        force(el, 'height', '100%');
        force(el, 'max-width', 'none');
        force(el, 'min-width', '0');
        force(el, 'max-height', 'none');
        force(el, 'object-fit', 'contain');
        force(el, 'object-position', 'center');
        force(el, 'margin', '0');
        force(el, 'padding', '0');
        force(el, 'z-index', z);
        // only the hover zoom may transform the photo; clear any entrance slide
        if (!el.style.transform || el.style.transform === 'none' || el.style.transform.indexOf('scale') === -1) {
          force(el, 'transform', 'none');
        }
      }

      // Resting state, applied once per card. The transition is withheld until
      // the next frame so the first paint does not fade the image out.
      // Products in the best-seller collection (handles from Liquid). The
      // app's JSON only carries tags, so collection membership is added here.
      var bestList = (host.getAttribute('data-best-sellers') || '').split(',');
      var BEST = {};
      for (var bi = 0; bi < bestList.length; bi++) {
        var bh = bestList[bi].trim();
        if (bh) BEST[bh] = true;
      }
      function badgeBest(card) {
        if (card.querySelector('.product-card__badge--best')) return;
        var heart = card.querySelector('[data-wishlist]');
        var handle = heart && heart.getAttribute('data-wishlist');
        if (!handle || !BEST[handle]) return;
        var media = card.querySelector('.product-card__media');
        if (!media) return;
        var wrap = media.querySelector('.product-card__badges');
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'product-card__badges';
          media.insertBefore(wrap, heart || null);
        }
        // one badge only: Best Selling takes the place of the offer badge
        while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
        var badge = document.createElement('span');
        badge.className = 'product-card__badge product-card__badge--best';
        badge.textContent = 'Best Selling';
        wrap.appendChild(badge);
      }

      function prime(card) {
        try { badgeBest(card); } catch (e) { /* badge is cosmetic */ }
        if (card.getAttribute('data-hover-ready') === '1') return;
        card.setAttribute('data-hover-ready', '1');

        var hover = card.querySelector(HOVER);
        var main = card.querySelector(MAIN);

        if (main) {
          pin(main, '1');
          force(main, 'display', 'block');
          force(main, 'visibility', 'visible');
          force(main, 'opacity', '1');
        }
        if (!hover) return;

        force(hover, 'transition', 'none');
        if (canHover) {
          pin(hover, '2');
          force(hover, 'display', 'block');
          force(hover, 'visibility', 'visible');
          force(hover, 'opacity', '0');
        } else {
          // No hover on touch: the second photo must never appear.
          force(hover, 'display', 'none');
        }

        if (canHover && window.requestAnimationFrame) {
          window.requestAnimationFrame(function () {
            force(hover, 'transition', 'opacity 0.45s ease, transform 0.45s ease');
            if (main) force(main, 'transition', 'opacity 0.45s ease, transform 0.45s ease');
          });
        }
      }

      function swap(card, on) {
        var hover = card.querySelector(HOVER);
        var main = card.querySelector(MAIN);
        // The gentle push-in the theme's own cards use, set here too so a
        // transform from the app cannot scale either photo away.
        var zoom = on ? 'scale(1.05)' : 'none';

        if (main) {
          // Whatever the app tries, the photo underneath never disappears.
          pin(main, '1');
          force(main, 'display', 'block');
          force(main, 'visibility', 'visible');
          force(main, 'opacity', '1');
          force(main, 'transform', zoom);
        }
        if (!hover) return;
        pin(hover, '2');
        force(hover, 'display', 'block');
        force(hover, 'visibility', 'visible');
        force(hover, 'opacity', on ? '1' : '0');
        force(hover, 'transform', zoom);
      }

      function primeAll() {
        var cards = document.querySelectorAll(CARD);
        for (var i = 0; i < cards.length; i++) prime(cards[i]);
      }

      if (canHover) {
        document.addEventListener('mouseover', function (event) {
          var t = event.target;
          if (!t || !t.closest) return;
          var card = t.closest(CARD);
          if (!card) return;
          prime(card);
          swap(card, true);
        });

        document.addEventListener('mouseout', function (event) {
          var t = event.target;
          if (!t || !t.closest) return;
          var card = t.closest(CARD);
          if (!card) return;
          // Moving between children of the same card is not a leave.
          var to = event.relatedTarget;
          if (to && card.contains(to)) return;
          swap(card, false);
        });
      }

      primeAll();

      // The app re-renders its grid on every filter change.
      var timer = null;
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(primeAll, 60);
        }).observe(document.body, { childList: true, subtree: true });
      }

      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        primeAll();
        if (tries > 40) clearInterval(poll);
      }, 250);
    }

    /* Keeps the filter column parked under the header while the products scroll.
       CSS `position: sticky` does the work wherever it is allowed to; if an
       ancestor clips or transforms and silently kills it, this falls back to a
       scroll-driven translate, which no ancestor can defeat. */
    stickySidebar() {
      var bar = this.querySelector('.collection-page__sidebar');
      var layout = this.querySelector('.collection-page__layout');
      if (!bar || !layout) return;

      var GAP = 16;
      var mode = 'css';
      var ticking = false;
      var checks = 0;

      var headerEl = document.querySelector('sticky-header') || document.querySelector('.site-header');
      function headerHeight() {
        // Header slid away: the column rises to the top instead of leaving a gap
        if (headerEl && headerEl.classList.contains('is-hidden')) return 0;
        var px = headerEl ? headerEl.getBoundingClientRect().height : 0;
        return px > 0 ? px : 64;
      }

      function measure() {
        if (window.innerWidth < 990) {
          bar.style.transform = '';
          return null;
        }
        var top = headerHeight() + GAP;
        bar.style.top = top + 'px';
        bar.style.maxHeight = 'calc(100vh - ' + (top + GAP) + 'px)';
        return top;
      }

      function place() {
        var top = measure();
        if (top === null) return;
        bar.style.transform = 'none';
        var r = bar.getBoundingClientRect();
        var lay = layout.getBoundingClientRect();
        var shift = top - r.top;
        if (shift < 0) shift = 0;
        var room = lay.bottom - (r.top + bar.offsetHeight);
        if (shift > room) shift = room > 0 ? room : 0;
        bar.style.transform = shift ? 'translateY(' + shift + 'px)' : 'none';
      }

      function engage() {
        if (mode === 'js') return;
        mode = 'js';
        bar.classList.add('is-js-sticky');
        place();
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          if (mode === 'js') {
            place();
            return;
          }
          if (checks > 30) return;
          checks++;
          var top = measure();
          if (top === null) return;
          var r = bar.getBoundingClientRect();
          var lay = layout.getBoundingClientRect();
          // Scrolled past the column's start, still room left below it, yet the
          // column has drifted above where it should hold: sticky isn't working.
          if (lay.top < top - 2 && lay.bottom - bar.offsetHeight > top + 2 && r.top < top - 2) {
            engage();
          }
        });
      }

      measure();
      bar.style.transition = 'top 0.3s ease';
      // Re-place the column whenever the header hides or comes back
      if (headerEl && window.MutationObserver) {
        new MutationObserver(function () {
          if (mode === 'js') place();
          else measure();
        }).observe(headerEl, { attributes: true, attributeFilter: ['class'] });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        checks = 0;
        if (mode === 'js') place();
        else measure();
      });
    }

    /* In 'auto' mode the theme's filters stand down as soon as the filter app
       (Globo Smart Product Filter) puts its own on the page, so the shopper
       never sees two filter columns — and still sees the theme's if the app
       never loads. */
    watchFilterApp() {
      /* Only the "stand the theme's own filters down" decision belongs to auto
         mode. Everything else in here — laying out the app's grid, rupee
         prices, the sticky filter column, one pager, the load-more pill — is
         styling the app's output and has to run whenever the app is on the
         page. */
      var autoMode = this.getAttribute('data-filter-source') === 'auto';

      var host = this;
      var found = false;

      /* Globo's rendered markup is prefixed gf- (#gf-tree, #gf-grid,
         #gf-products, #gf-quick-filters). The gspf- prefix belongs to its
         assets and to the <script id="gspfProduct"> template, which is not a
         rendered UI — matching only that was why the app went undetected and
         the theme's own filters stayed on the page beside it. */
      function appIsLive() {
        var nodes = document.querySelectorAll(
          '[id^="gf-"], [class*="gf-tree"], [class*="gf-grid"], [class*="gf-filter"], .spf-has-filter, [id^="gspf"], [class*="gspf"]'
        );
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          var tag = n.nodeName;
          if (tag === 'SCRIPT' || tag === 'TEMPLATE' || tag === 'STYLE' || tag === 'LINK') continue;
          if (n.offsetWidth > 0 || n.offsetHeight > 0 || n.getClientRects().length > 0) return true;
        }
        return false;
      }

      var ownsResults = false;

      /* Globo renders its own product grid. Once its cards are on the page the
         theme's grid and pagination are a duplicate, so they stand down — but
         only after checking the app hasn't injected INTO the theme grid, in
         which case hiding it would hide the results themselves. */
      function appOwnsResults() {
        var grid = host.querySelector('.collection-page__grid');
        if (!grid) return false;
        if (grid.querySelector('[class*="spf-col"]')) return false;
        var cards = document.querySelector('[class*="spf-col"], #gf-products [class*="product"]');
        if (!cards || grid.contains(cards)) return false;
        return true;
      }

      /* ---- Laying out the filter app's grid ----
         Globo ships its own per-row CSS with !important, and its markup may
         wrap the theme's card in a div of its own, so neither the app's class
         names nor a stylesheet rule can be relied on. Instead the real DOM is
         measured: find the element that actually holds several cards (the row)
         and the element that represents one column (the unit, which may be the
         card or the app's wrapper around it), then set the widths inline with
         priority, which nothing in a stylesheet can outrank. */
      function columnCount() {
        return window.innerWidth < 750 ? 2 : 3;
      }

      function holdsCard(el) {
        if (!el || !el.classList) return false;
        if (el.classList.contains('jogger-spf-col')) return true;
        return !!el.querySelector('.jogger-spf-col');
      }

      // Walk up from a card until a parent holds two or more sibling columns,
      // so the app wrapping the theme's card in a div of its own is handled.
      function unitAndRow(card) {
        var node = card;
        var guard = 0;
        while (node.parentNode && node.parentNode !== document.body && guard < 12) {
          guard++;
          var p = node.parentNode;
          var siblings = 0;
          for (var i = 0; i < p.children.length; i++) {
            if (holdsCard(p.children[i])) siblings++;
          }
          if (siblings >= 2) return { unit: node, row: p };
          node = p;
        }
        return null;
      }

      function isProductCell(el) {
        if (!el || el.nodeType !== 1) return false;
        if (el.querySelector) {
          if (el.querySelector('a[href*="/products/"]')) return true;
        }
        return false;
      }

      /* Finding the app's grid without knowing its class names.
         The theme's own template tags cards with .jogger-spf-col, but the app
         may be rendering its default template instead, in which case that
         class is absent. So the fallback works off the product links
         themselves: the row is the element with the most children that each
         hold exactly one product link, ignoring the theme's own grid. */
      function findAppRow() {
        var cards = document.querySelectorAll('.jogger-spf-col');
        if (cards.length) {
          var pair = unitAndRow(cards[0]);
          if (pair) return pair.row;
          return cards[0].parentNode;
        }

        var themeGrid = host.querySelector('.collection-page__grid');
        var links = document.querySelectorAll('a[href*="/products/"]');
        var seen = [];
        var best = null;
        var bestCount = 0;

        for (var i = 0; i < links.length; i++) {
          var node = links[i];
          var depth = 0;
          while (node && node.parentNode && depth < 7) {
            depth++;
            var p = node.parentNode;
            node = p;
            if (p === document.body || !p.children) break;
            if (themeGrid && (p === themeGrid || themeGrid.contains(p))) continue;
            if (seen.indexOf(p) !== -1) continue;
            seen.push(p);

            var cells = 0;
            for (var j = 0; j < p.children.length; j++) {
              if (isProductCell(p.children[j])) cells++;
            }
            if (cells >= 2 && cells > bestCount) {
              bestCount = cells;
              best = p;
            }
          }
        }
        return best;
      }

      function layoutAppGrid() {
        var row = findAppRow();
        if (!row || !row.style) return;

        // A grid, matching the stylesheet. Inline and with priority so the
        // app's own display and width rules cannot put the cards back into a
        // single column, whichever stylesheet loaded last.
        var cols = columnCount();
        row.classList.add('jogger-spf-row');
        row.style.setProperty('display', 'grid', 'important');
        row.style.setProperty('grid-template-columns', 'repeat(' + cols + ', minmax(0, 1fr))', 'important');
        row.style.setProperty('align-items', 'stretch', 'important');
        row.style.setProperty('float', 'none', 'important');
        // The app sets a negative side margin on this element; it would pull
        // the first and last card past the page gutter.
        row.style.setProperty('margin-left', '0', 'important');
        row.style.setProperty('margin-right', '0', 'important');

        for (var i = 0; i < row.children.length; i++) {
          var unit = row.children[i];
          if (!unit.style) continue;
          if (!holdsCard(unit) && !isProductCell(unit)) continue;
          // The card fills its track. Any width the app set would make it a
          // fraction of its own cell instead.
          unit.style.setProperty('width', 'auto', 'important');
          unit.style.setProperty('max-width', 'none', 'important');
          unit.style.setProperty('min-width', '0', 'important');
          unit.style.setProperty('flex', 'initial', 'important');
          unit.style.setProperty('float', 'none', 'important');
          unit.style.setProperty('padding', '0', 'important');
          unit.style.setProperty('margin', '0', 'important');
          unit.style.setProperty('box-sizing', 'border-box', 'important');
        }
      }

      /* The app's filter column, made to hold under the header. CSS does it
         where allowed; the offset is set from the measured header height here
         because the app's column lives outside the theme's markup and may be
         re-rendered on every filter change. */
      function appFilterColumn() {
        var direct = document.querySelector('#gf-tree, .gf-tree, #gspf-filter-tree, .gspf-filter-tree');
        if (direct) return direct;

        // Fall back to the column that holds the filter groups but no products
        var products = document.querySelector('#gf-products, [class*="spf-col"]');
        var candidates = document.querySelectorAll('[id^="gf-"], [id^="gspf"], [class*="gf-tree"]');
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          if (!el.getElementsByTagName) continue;
          if (products && (el.contains(products) || el === products)) continue;
          if (el.querySelector('input[type="checkbox"], input[type="radio"]')) return el;
        }
        return null;
      }

      function stickAppFilters() {
        var col = appFilterColumn();
        if (!col || !col.style) return;

        if (window.innerWidth < 990) {
          col.style.removeProperty('position');
          col.style.removeProperty('top');
          col.style.removeProperty('max-height');
          col.style.removeProperty('overflow-y');
          return;
        }

        var header = document.querySelector('sticky-header') || document.querySelector('.site-header');
        var hh = header ? header.getBoundingClientRect().height : 0;
        if (!(hh > 0)) hh = 64;
        // Header slid away on scroll-down: rise to the top, no gap
        if (header && header.classList.contains('is-hidden')) hh = 0;
        var top = Math.round(hh) + 16;

        if (header && !header.__joggerAppWatch && window.MutationObserver) {
          header.__joggerAppWatch = true;
          new MutationObserver(stickAppFilters).observe(header, { attributes: true, attributeFilter: ['class'] });
        }

        col.style.setProperty('position', 'sticky', 'important');
        col.style.setProperty('top', top + 'px', 'important');
        col.style.setProperty('align-self', 'flex-start', 'important');
        col.style.setProperty('max-height', 'calc(100vh - ' + (top + 16) + 'px)', 'important');
        col.style.setProperty('overflow-y', 'auto', 'important');

        // A clipping ancestor silently kills sticky, so clear it on the way up
        var node = col.parentNode;
        var guard = 0;
        while (node && node.nodeType === 1 && node !== document.body && guard < 6) {
          guard++;
          var cs = window.getComputedStyle(node);
          if (cs.overflow === 'hidden' || cs.overflowY === 'hidden') {
            node.style.setProperty('overflow', 'visible', 'important');
          }
          node = node.parentNode;
        }
      }

      /* Tag and hide whichever pager the merchant does not want. The app's is
         found by its own naming, then by any pager-shaped list of page links
         that is not the theme's own. */
      function syncPagination() {
        var mode = host.getAttribute('data-pagination') || 'theme';
        if (mode === 'both') return;

        var themePager = host.querySelector('.collection-page__pagination, .collection-page__more');
        var appPagers = [];

        var named = document.querySelectorAll(
          '#gf-pagination, .gf-pagination, [id^="gf-pagination"], [class*="gf-pagination"], .spf-pagination, [class*="gspf-pagination"]'
        );
        for (var i = 0; i < named.length; i++) appPagers.push(named[i]);

        if (!appPagers.length) {
          // Nothing named: look for a block of numbered page links that is not
          // the theme's pager.
          var blocks = document.querySelectorAll('[class*="pagination"], [class*="paginate"], [id*="pagination"]');
          for (var j = 0; j < blocks.length; j++) {
            var b = blocks[j];
            if (themePager && (b === themePager || themePager.contains(b) || b.contains(themePager))) continue;
            if (!host.contains(b) && b.closest && b.closest('collection-page') !== host) continue;
            appPagers.push(b);
          }
        }

        for (var k = 0; k < appPagers.length; k++) {
          var el = appPagers[k];
          if (!el.classList) continue;
          el.classList.add('jogger-app-pagination');
          if (mode === 'theme') el.style.setProperty('display', 'none', 'important');
          else el.style.removeProperty('display');
        }

        if (themePager && themePager.style) {
          if (mode === 'app') themePager.style.setProperty('display', 'none', 'important');
          else themePager.style.removeProperty('display');
        }
      }

      /* The app's load-more button, centred and given the theme's pill.
         Its class names differ between the app's versions, so it is found by
         its own naming first and then by a button whose only text is Load
         more / Loading — never one inside a product card or the theme's own
         load-more control. */
      function tagLoadMore() {
        var named = document.querySelectorAll(
          '#gf-load-more, .gf-load-more, [id^="gf-load"], [class*="gf-load-more"], [class*="spf-load-more"]'
        );
        var found = [];
        for (var i = 0; i < named.length; i++) found.push(named[i]);

        if (!found.length) {
          var buttons = document.querySelectorAll('button, a');
          for (var j = 0; j < buttons.length; j++) {
            var el = buttons[j];
            if (el.closest && (el.closest('.product-card') || el.hasAttribute('data-load-more'))) continue;
            var text = (el.textContent || '').trim().toLowerCase();
            if (text === 'load more' || text === 'loading' || text === 'loading...') found.push(el);
          }
        }

        for (var k = 0; k < found.length; k++) {
          var btn = found[k];
          if (!btn.classList) continue;
          btn.classList.add('jogger-load-more');
          var wrap = btn.parentNode;
          if (wrap && wrap.classList && wrap.children.length === 1) {
            wrap.classList.add('jogger-load-more-wrap');
          }
        }
      }

      /* The design's "Filters" title and Men / Women switch, placed at the top
         of Globo's filter column. Globo rebuilds the column when filters
         change, so this runs again after every re-render. */
      var headTpl = host.querySelector('template[data-gf-head-template]');
      function injectFilterHead() {
        if (!headTpl) return;
        var tree = document.querySelector('#gf-tree');
        if (!tree || tree.querySelector('.jogger-gf-head')) return;
        // Wait for real filter groups, not Globo's loading skeleton
        if (!tree.querySelector('.gf-option-block')) return;
        var head = headTpl.content.firstElementChild.cloneNode(true);
        // If Globo already offers a gender filter, don't show a second one
        var titles = tree.querySelectorAll('.gf-block-title h3, .gf-block-title .h3');
        for (var t = 0; t < titles.length; t++) {
          if (/gender/i.test(titles[t].textContent || '')) {
            var g = head.querySelector('[data-gf-gender]');
            if (g) g.remove();
            break;
          }
        }
        tree.insertBefore(head, tree.firstChild);
      }

      function tagRow() {
        try {
          injectFilterHead();
        } catch (e) {
          /* the header is cosmetic; Globo's filters still work without it */
        }
        try {
          tagLoadMore();
        } catch (e) {
          /* an unstyled button is cosmetic, never fatal */
        }
        try {
          layoutAppGrid();
        } catch (e) {
          /* layout is best-effort; never break the page over it */
        }
        try {
          host.repriceAppCards();
        } catch (e) {
          /* leave the app's own formatting in place if this fails */
        }
        try {
          stickAppFilters();
        } catch (e) {
          /* a non-sticky column is a nuisance, not a failure */
        }
        try {
          syncPagination();
        } catch (e) {
          /* two pagers is untidy, not broken */
        }
      }

      window.addEventListener('resize', tagRow);

      var rowTimer = null;
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          if (rowTimer) clearTimeout(rowTimer);
          rowTimer = setTimeout(tagRow, 60);
        }).observe(document.body, { childList: true, subtree: true });
      }
      tagRow();

      // The app renders late and in stages, so retry for a while rather than
      // trusting a single pass.
      var layoutTries = 0;
      var layoutTimer = setInterval(function () {
        layoutTries++;
        tagRow();
        if (layoutTries > 40) clearInterval(layoutTimer);
      }, 250);
      if (window.addEventListener) {
        window.addEventListener('load', tagRow);
      }

      function check() {
        if (!autoMode) return true;
        if (!found && appIsLive()) {
          found = true;
          host.classList.add('app-live');
        }
        if (found && !ownsResults && appOwnsResults()) {
          ownsResults = true;
          host.classList.add('app-owns-results');
          tagRow();
        }
        return found && ownsResults;
      }

      if (check()) return;

      // The app injects after its own scripts run, so watch for a while.
      var observer = null;
      var timer = null;
      function stop() {
        if (observer) observer.disconnect();
        if (timer) clearInterval(timer);
      }
      if ('MutationObserver' in window) {
        observer = new MutationObserver(function () {
          if (check()) stop();
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
      var ticks = 0;
      timer = setInterval(function () {
        ticks++;
        if (check() || ticks > 40) stop();
      }, 250);
    }
  }
  if (!customElements.get('collection-page')) customElements.define('collection-page', CollectionPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-gallery"] && !Shopify.designMode) return;
  try {
    
  class CommunityGallery extends HTMLElement {
    connectedCallback() {
      try {
        this.lazyEmbeds();
      } catch (e) {
        /* the gallery is decorative; never break the page over it */
      }

      try {
        this.fitMediaFrames();
      } catch (e) {
        /* an unclipped frame is ugly, not fatal */
      }
    }

    /* Clipping Instagram's iframe down to just the media.
       Inside the embed, at a given width w, the layout is:
         header  ~54px
         media   ~w  (square; taller posts simply crop, like object-fit cover)
         actions ~200px  (like / comment / share, like count, comment box)
       So the frame is laid out at width w, scaled until the media band fills
       the card, then shifted up by the header and centred horizontally.
       The src itself is set by jogger.js once the card nears the viewport
       ([data-lazy-iframe]); the clip shimmers until the frame reports load. */
    fitMediaFrames() {
      var clips = this.querySelectorAll('[data-ig-clip]');
      if (!clips.length) return;

      var HEADER = 54;
      var FOOTER = 200;

      function fit(clip) {
        var frame = clip.querySelector('.community__frame');
        if (!frame) return;
        var w = clip.clientWidth;
        var h = clip.clientHeight;
        if (!w || !h) return;

        var scale = h / w;
        if (scale < 1) scale = 1;

        frame.style.width = w + 'px';
        frame.style.height = HEADER + w + FOOTER + 'px';

        var offsetY = -HEADER * scale;
        var offsetX = -((w * scale) - w) / 2;
        frame.style.transform =
          'translate(' + offsetX + 'px, ' + offsetY + 'px) scale(' + scale + ')';
      }

      var all = function () {
        for (var i = 0; i < clips.length; i++) fit(clips[i]);
      };

      all();

      for (var c = 0; c < clips.length; c++) {
        (function (clip) {
          var frame = clip.querySelector('.community__frame');
          if (!frame) return;
          frame.addEventListener('load', function () {
            if (frame.getAttribute('src')) clip.classList.add('is-loaded');
          });
        })(clips[c]);
      }

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(all);
        for (var i = 0; i < clips.length; i++) ro.observe(clips[i]);
      } else {
        var t = null;
        window.addEventListener('resize', function () {
          if (t) clearTimeout(t);
          t = setTimeout(all, 120);
        });
      }
    }

    /* Instagram's embed.js is heavy and nothing above the fold needs it, so it
       is fetched only once this section nears the viewport, and only once per
       page however many galleries are on it. */
    lazyEmbeds() {
      var wrap = this.querySelector('[data-ig-embeds]');
      if (!wrap) return;

      function load() {
        if (window.__joggerIgEmbed) {
          if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
          return;
        }
        window.__joggerIgEmbed = true;
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.instagram.com/embed.js';
        document.body.appendChild(s);
      }

      if (!('IntersectionObserver' in window)) {
        load();
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            io.disconnect();
            load();
            return;
          }
        },
        { rootMargin: '400px' }
      );
      io.observe(wrap);
    }
  }
  if (!customElements.get('community-gallery')) customElements.define('community-gallery', CommunityGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      try {
        this.init();
      } catch (err) {
        // A single failure must not disable add-to-cart, pincode, wishlist…
        console.error('Product section:', err);
      }
    }

    init() {
      try {
        this.setupSizeChart();
      } catch (e) {
        /* the chart is a nicety; never let it block the buy path */
      }
      try {
        this.setupLightbox();
      } catch (e) {
        /* the image viewer is a nicety; never let it block the buy path */
      }

      this.form = this.querySelector('form');
      const json = this.querySelector('[data-product-json]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.idInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.discountEl = this.querySelector('[data-discount]');
      this.addBtn = this.querySelector('[data-add-to-bag]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.buyBtn = this.querySelector('[data-buy-now]');
      this.errorEl = this.querySelector('[data-form-error]');

      this.querySelectorAll('.pdp__swatch-input').forEach((input) => {
        input.addEventListener('change', () => {
          this.onOptionChange();
          // Colour drives the gallery — refresh it directly too, so it updates
          // even when no variant matches the current size selection.
          const ownFs = input.closest('.pdp__option');
          if (ownFs && ownFs === this.colorFieldset()) {
            const sel = this.selectedOptions();
            const match = this.variants.find((v) =>
              sel.every((val, i) => val === null || v.options[i] === val)
            );
            this.updateGallery(match || null);
          }
        });
      });
      if (this.variants.length) {
        this.refreshValueAvailability();
        const sel = this.selectedOptions();
        const current = this.variants.find((v) => sel.every((val, i) => val === null || v.options[i] === val));
        if (current) this.updateGallery(current);
      }

      // Back from checkout via the back/forward cache: the Buy Now buttons
      // must not still be spinning.
      window.addEventListener('pageshow', () => this.setBusy('buy', false));

      if (this.buyBtn) {
        this.buyBtn.addEventListener('click', () => this.buyNow(this.buyBtn));
      }
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.ajaxAdd(this.addBtn);
        });
      }

      // Gallery arrows — drive the same scroll-snap track the gestures use
      this.track = this.querySelector('.pdp__gallery .carousel__track');
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.countEl = this.querySelector('[data-gallery-count]');
      this.dotsWrap = this.querySelector('[data-gallery-dots]');
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      if (this.track) {
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.slideBy(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.slideBy(1));
        let raf = 0;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.syncGalleryNav());
        }, { passive: true });
        window.addEventListener('resize', () => this.syncGalleryNav(), { passive: true });
        this.syncGalleryNav();
      }

      // Fixed mobile buy bar: the same add / buy paths as the inline buttons
      document.body.classList.add('pdp-page');
      const bar = this.querySelector('[data-buybar]');
      // always on screen on phones, so the whole page keeps clear of it
      if (bar) document.body.classList.add('pdp-buybar-fixed');
      // the dock is hidden on product pages: refresh --dock-height right away
      if (window.Jogger && typeof window.Jogger.syncLayoutVars === 'function') window.Jogger.syncLayoutVars();
      this.barAdd = this.querySelector('[data-buybar-add]');
      this.barBuy = this.querySelector('[data-buybar-buy]');
      if (this.barAdd) {
        this.barAdd.addEventListener('click', () => this.ajaxAdd(this.barAdd));
      }
      if (this.barBuy) {
        this.barBuy.addEventListener('click', () => this.buyNow(this.barBuy));
      }
      try {
        this.setupBuybar(bar);
      } catch (e) {
        /* the bar is a convenience; never let it block the buy path */
      }

      // Merchant tables in the rich text scroll sideways instead of widening the page
      this.querySelectorAll('.pdp__acc-body table').forEach((table) => {
        if (table.parentElement && table.parentElement.classList.contains('table-scroll')) return;
        const wrap = document.createElement('div');
        wrap.className = 'table-scroll';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      });

      // "Added to cart" dialog + share sheet
      try {
        this.setupAdded();
      } catch (e) {
        /* the dialog is feedback only; the item is already in the cart */
      }
      try {
        this.setupShare();
      } catch (e) {
        /* sharing is a nicety; never let it block the buy path */
      }

      // Pincode delivery check
      try {
        this.setupDeliveryCheck();
      } catch (e) {
        /* the delivery check is a nicety; never let it block the buy path */
      }
    }

    /* ---- Fixed mobile buy bar ----
       Always on screen on phones (the inline buttons are hidden there) and
       gone from tablet up. Its height is published as --buybar-height so
       the section and the page reserve room beneath the last content. */
    setupBuybar(bar) {
      if (!bar) return;
      const tablet = window.matchMedia('(min-width: 750px)');
      const root = document.documentElement;
      const measure = () => {
        const h = tablet.matches ? 0 : bar.offsetHeight;
        root.style.setProperty('--buybar-height', h + 'px');
        bar.setAttribute('aria-hidden', tablet.matches ? 'true' : 'false');
      };
      if (tablet.addEventListener) tablet.addEventListener('change', measure);
      else if (tablet.addListener) tablet.addListener(measure);
      window.addEventListener('resize', measure, { passive: true });
      window.addEventListener('orientationchange', measure, { passive: true });
      measure();

      // Show the bar only while the product section itself is on screen:
      // once its bottom edge scrolls above the viewport (reviews, similar
      // products, footer) the bar slides away, and returns on the way back up.
      const section = this;
      let away = false;
      const setAway = (next) => {
        if (next === away) return;
        away = next;
        bar.classList.toggle('is-away', away);
      };
      const check = () => {
        if (tablet.matches) return setAway(false);
        const r = section.getBoundingClientRect();
        const barH = bar.offsetHeight || 56;
        // past the section when its bottom is above the bar's top edge
        setAway(r.bottom <= window.innerHeight - barH || r.top >= window.innerHeight);
      };
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          check();
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      check();
    }

    /* ---- Loading state on a pair of buttons (inline + fixed bar) ---- */
    setBusy(which, busy) {
      const pair = which === 'buy' ? [this.buyBtn, this.barBuy] : [this.addBtn, this.barAdd];
      pair.filter(Boolean).forEach((b) => {
        b.classList.toggle('is-loading', !!busy);
        if (busy) b.setAttribute('aria-busy', 'true');
        else b.removeAttribute('aria-busy');
      });
    }

    /* ---- Inline error (sold out, failed add, failed Buy Now) ---- */
    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || 'Something went wrong. Please try again.';
      this.errorEl.hidden = false;
      const r = this.errorEl.getBoundingClientRect();
      const bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--buybar-height')) || 0;
      if (r.top < 0 || r.bottom > window.innerHeight - bar) {
        this.errorEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    /* ---- Accessible dialog shell shared by the share sheet and the
       "added to cart" popup: open/close, backdrop, Escape, focus trap. ---- */
    createDialog(root, backdrop, bodyClass, closeSelector) {
      if (!root) return null;
      const panel = root.querySelector('[tabindex="-1"]') || root;
      let opener = null;
      const focusables = () =>
        Array.from(root.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')).filter(
          (el) => el.offsetParent !== null
        );
      const api = {
        isOpen: () => root.getAttribute('aria-hidden') === 'false',
        open(from) {
          opener = from || document.activeElement;
          root.setAttribute('aria-hidden', 'false');
          if (backdrop) backdrop.classList.add('is-open');
          document.body.classList.add(bodyClass);
          root.dispatchEvent(new CustomEvent('dialog:open'));
          // wait a frame: the panel is still visibility:hidden as it starts to slide in
          setTimeout(() => {
            const first = root.querySelector('[data-autofocus]') || root.querySelector(closeSelector) || focusables()[0] || panel;
            try {
              first.focus({ preventScroll: true });
            } catch (e) {
              first.focus();
            }
          }, 60);
        },
        close() {
          if (!api.isOpen()) return;
          root.setAttribute('aria-hidden', 'true');
          if (backdrop) backdrop.classList.remove('is-open');
          document.body.classList.remove(bodyClass);
          root.dispatchEvent(new CustomEvent('dialog:close'));
          if (opener && opener.focus && document.contains(opener)) {
            try {
              opener.focus({ preventScroll: true });
            } catch (e) {
              /* noop */
            }
          }
          opener = null;
        },
      };
      root.querySelectorAll(closeSelector).forEach((el) => el.addEventListener('click', () => api.close()));
      if (backdrop) backdrop.addEventListener('click', () => api.close());
      // a tap on the dimmed area inside the dialog box (around the panel) closes too
      root.addEventListener('click', (e) => {
        if (e.target === root) api.close();
      });
      document.addEventListener('keydown', (e) => {
        if (!api.isOpen()) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          api.close();
          return;
        }
        if (e.key !== 'Tab') return;
        const items = focusables();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (!root.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
      return api;
    }

    /* ---- "Added to cart" dialog ---- */
    setupAdded() {
      this.added = this.querySelector('[data-added]');
      this.addedDialog = this.createDialog(this.added, this.querySelector('[data-added-backdrop]'), 'pdp-added-open', '[data-added-close]');
    }

    /* ---- Share: native sheet on touch devices, our own sheet otherwise ---- */
    setupShare() {
      const btn = this.querySelector('[data-share-open]');
      const sheet = this.querySelector('[data-share]');
      if (!btn || !sheet) return;
      const url = sheet.dataset.shareUrl || window.location.href.split('?')[0];
      const text = sheet.dataset.shareText || document.title;
      const dlg = this.createDialog(sheet, this.querySelector('[data-share-backdrop]'), 'share-sheet-open', '[data-share-close]');
      if (!dlg) return;
      sheet.addEventListener('dialog:open', () => btn.setAttribute('aria-expanded', 'true'));
      sheet.addEventListener('dialog:close', () => btn.setAttribute('aria-expanded', 'false'));

      btn.addEventListener('click', () => {
        const touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
        if (touch && typeof navigator.share === 'function') {
          navigator.share({ title: text, text: text, url: url }).catch((err) => {
            // the shopper dismissed it: nothing to do; anything else: our sheet
            if (!err || err.name !== 'AbortError') dlg.open(btn);
          });
          return;
        }
        dlg.open(btn);
      });

      const copy = sheet.querySelector('[data-share-copy]');
      const label = sheet.querySelector('[data-share-copy-label]');
      const status = sheet.querySelector('[data-share-status]');
      if (!copy) return;
      let resetTimer = null;
      const copyText = (value) => {
        const fallback = () => {
          try {
            const ta = document.createElement('textarea');
            ta.value = value;
            ta.setAttribute('readonly', '');
            ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
            document.body.appendChild(ta);
            ta.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(ta);
            return ok;
          } catch (e) {
            return false;
          }
        };
        if (navigator.clipboard && window.isSecureContext) {
          return navigator.clipboard.writeText(value).then(() => true, () => fallback());
        }
        return Promise.resolve(fallback());
      };
      copy.addEventListener('click', () => {
        copyText(url).then((ok) => {
          const done = ok ? (label && label.dataset.done) || 'Link copied' : 'Copy failed';
          if (label) label.textContent = done;
          copy.classList.toggle('is-done', ok);
          if (status) status.textContent = ok ? 'Link copied to clipboard' : 'Could not copy the link';
          clearTimeout(resetTimer);
          resetTimer = setTimeout(() => {
            if (label) label.textContent = label.dataset.default || 'Copy link';
            copy.classList.remove('is-done');
          }, 2400);
        });
      });
    }

    /* ---- Pincode delivery check ----
       Where the details come from is chosen in the theme editor
       (Product details → Delivery check → Delivery details source):
         india_post — area name from India Post's free pincode lookup,
                      delivery days from the section settings;
         endpoint   — your delivery app's link (or app proxy), which
                      returns JSON with the area, days or date, and
                      whether the pincode is serviceable;
         days_only  — no lookup; the pincode plus the days below.
       "Pincode delivery days" rules (prefix | days) override the days in
       every mode, and "no" marks a prefix as not deliverable. */
    setupDeliveryCheck() {
      const box = this.querySelector('[data-delivery]');
      if (!box) return;
      const input = box.querySelector('[data-pincode-input]');
      const btn = box.querySelector('[data-pincode-check]');
      const msg = box.querySelector('[data-pincode-msg]');
      const result = box.querySelector('[data-delivery-result]');
      const areaEl = box.querySelector('[data-delivery-area]');
      const labelEl = box.querySelector('[data-delivery-label]');
      const dateEl = box.querySelector('[data-delivery-date]');
      const etaRow = box.querySelector('[data-delivery-eta-row]');
      const firstRow = result ? result.querySelector('.pdp__delivery-row') : null;
      const edit = box.querySelector('[data-delivery-edit]');
      if (!input || !btn || !msg || !result) return;

      const source = box.dataset.source || 'india_post';
      // "city, etd_days, etd, serviceable" → where each value sits in the app's JSON
      const fields = (box.dataset.fields || 'city, etd_days, etd, serviceable').split(',').map((f) => f.trim());
      const keyArea = fields[0] || '';
      const keyDays = fields[1] || '';
      const keyDate = fields[2] || '';
      const keyServiceable = fields[3] || '';
      const skipSundays = box.dataset.skipSundays !== 'false';
      const minDefault = parseInt(this.dataset.deliveryMin || '3', 10);
      const maxDefault = parseInt(this.dataset.deliveryMax || '7', 10);
      const labelText = labelEl ? labelEl.textContent : 'Delivery To,';
      const STORE_KEY = 'jogger:pincode';
      const cache = (window.__joggerPincodeCache = window.__joggerPincodeCache || {});

      // "673, 682 | 2"  "560 | 3-5"  "799 | no"
      const rules = (box.dataset.rules || '')
        .split(/\n/)
        .map((line) => line.split('|'))
        .filter((parts) => parts.length === 2)
        .map(([prefixes, days]) => ({
          prefixes: prefixes.split(',').map((p) => p.trim()).filter(Boolean),
          days: days.trim().toLowerCase(),
        }));
      const ruleFor = (pin) => {
        let best = null;
        rules.forEach((r) =>
          r.prefixes.forEach((p) => {
            if (pin.indexOf(p) === 0 && (!best || p.length > best.len)) best = { len: p.length, days: r.days };
          })
        );
        return best ? best.days : null;
      };

      const addDays = (n) => {
        const d = new Date();
        let left = Math.max(0, n);
        while (left > 0) {
          d.setDate(d.getDate() + 1);
          if (skipSundays && d.getDay() === 0) continue;
          left -= 1;
        }
        return d;
      };
      // "Monday, 14 Sept" — built by hand so every browser shows the same text
      const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
      const formatDate = (d) => DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
      const pick = (obj, path) => {
        if (!path) return undefined;
        return path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);
      };
      const withTimeout = (url, ms) => {
        const ctrl = 'AbortController' in window ? new AbortController() : null;
        const timer = setTimeout(() => ctrl && ctrl.abort(), ms);
        return fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
          .finally(() => clearTimeout(timer));
      };

      // India Post: "Kozhikode HiLITE Business Park" style name, or null
      const indiaPostArea = (pin) =>
        withTimeout('https://api.postalpincode.in/pincode/' + pin, 6000)
          .then((data) => {
            const entry = Array.isArray(data) ? data[0] : null;
            if (!entry || entry.Status !== 'Success' || !entry.PostOffice || !entry.PostOffice.length) {
              return { found: false };
            }
            const offices = entry.PostOffice;
            const po = offices.find((o) => o.DeliveryStatus === 'Delivery') || offices[0];
            const district = (po.District || '').trim();
            const name = (po.Name || '').trim();
            const area = name && name.toLowerCase().indexOf(district.toLowerCase()) === -1 ? (district + ' ' + name).trim() : name || district;
            return { found: true, area: area };
          })
          .catch(() => ({ found: null })); // lookup unavailable: carry on without a name

      const appLookup = (pin) => {
        const tpl = box.dataset.endpoint || '';
        if (!tpl) return Promise.resolve({ found: null });
        const url = tpl.indexOf('{pincode}') > -1 ? tpl.split('{pincode}').join(pin) : tpl + (tpl.indexOf('?') > -1 ? '&' : '?') + 'pincode=' + pin;
        return withTimeout(url, 8000)
          .then((data) => {
            const serviceable = pick(data, keyServiceable);
            const days = parseInt(pick(data, keyDays), 10);
            const dateRaw = pick(data, keyDate);
            const date = dateRaw ? new Date(dateRaw) : null;
            return {
              found: true,
              serviceable: serviceable === undefined ? true : serviceable === true || serviceable === 1 || serviceable === 'true' || serviceable === 'yes',
              area: pick(data, keyArea) || '',
              days: isFinite(days) ? days : null,
              date: date && !isNaN(date.getTime()) ? date : null,
            };
          })
          .catch(() => ({ found: null }));
      };

      const lookup = (pin) => {
        if (cache[source + pin]) return Promise.resolve(cache[source + pin]);
        let job;
        if (source === 'endpoint') {
          job = appLookup(pin).then((app) => {
            if (app.found && app.area) return app;
            // the app gave no area name: fall back to India Post for it
            return indiaPostArea(pin).then((ip) => Object.assign({}, app, { area: ip.area || '', found: app.found || ip.found }));
          });
        } else if (source === 'india_post') {
          job = indiaPostArea(pin);
        } else {
          job = Promise.resolve({ found: null });
        }
        return job.then((res) => {
          if (res.found !== null) cache[source + pin] = res;
          return res;
        });
      };

      const showForm = (focus) => {
        box.removeAttribute('data-state');
        result.hidden = true;
        msg.classList.remove('is-error');
        msg.textContent = 'Enter pincode to see exact delivery timelines.';
        if (focus) {
          input.focus();
          input.select();
        }
      };
      const showError = (text) => {
        box.removeAttribute('data-state');
        result.hidden = true;
        msg.textContent = text;
        msg.classList.add('is-error');
      };
      const showResult = (pin, res) => {
        const rule = ruleFor(pin);
        const blocked = rule === 'no' || (res.serviceable === false);
        if (labelEl) labelEl.textContent = blocked ? 'Sorry, we don\'t deliver to' : labelText;
        areaEl.textContent = res.area || pin;
        if (firstRow) firstRow.classList.toggle('is-unavailable', blocked);
        if (etaRow) etaRow.hidden = blocked;
        if (!blocked) {
          let date = res.date || null;
          if (!date) {
            let days = res.days != null ? res.days : maxDefault;
            if (rule && rule !== 'no') {
              const range = rule.split('-').map((n) => parseInt(n, 10)).filter((n) => isFinite(n));
              if (range.length) days = range[range.length - 1];
            }
            date = addDays(days || minDefault);
          }
          dateEl.textContent = formatDate(date);
        }
        msg.classList.remove('is-error');
        result.hidden = false;
        box.setAttribute('data-state', 'result');
        if (edit) edit.setAttribute('aria-label', 'Change pincode ' + pin);
      };

      const check = (fromSaved) => {
        const pin = (input.value || '').replace(/\D/g, '');
        input.value = pin;
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          if (!fromSaved) showError('Please enter a valid 6-digit pincode.');
          return;
        }
        // read before the button is disabled (a disabled button drops focus)
        const hadFocus = !fromSaved && box.contains(document.activeElement);
        btn.disabled = true;
        const label = btn.textContent;
        btn.textContent = 'Checking…';
        lookup(pin)
          .then((res) => {
            if (res.found === false && source !== 'days_only') {
              showError('We couldn\'t find pincode ' + pin + '. Please check and try again.');
              if (hadFocus) input.focus();
              return;
            }
            showResult(pin, res);
            // the form is gone: keep keyboard focus next to the result
            if (hadFocus && edit) edit.focus();
            try {
              localStorage.setItem(STORE_KEY, pin);
            } catch (e) {}
          })
          .finally(() => {
            btn.disabled = false;
            btn.textContent = label;
          });
      };

      btn.addEventListener('click', () => check(false));
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          check(false);
        }
      });
      input.addEventListener('input', () => {
        if (msg.classList.contains('is-error')) showForm(false);
      });
      if (edit) edit.addEventListener('click', () => showForm(true));

      // Remember the shopper's pincode between product pages
      try {
        const saved = localStorage.getItem(STORE_KEY);
        if (saved) {
          input.value = saved;
          check(true);
        }
      } catch (e) {}
    }

    /* ---- Add to bag: AJAX add, then the "added" sheet / modal ---- */
    ajaxAdd(trigger) {
      if (!this.form || !this.addBtn || this.addBtn.disabled || this._adding) return;
      this._adding = true;
      this.clearError();
      const label = this.addLabel ? this.addLabel.textContent : '';
      if (this.addLabel) this.addLabel.textContent = 'Adding…';
      this.setBusy('add', true);

      this.postAdd()
        .then((item) => {
          this.showAdded(item, trigger);
          this.refreshCartCount();
        })
        .catch((err) => this.showError(err && err.message))
        .finally(() => {
          this._adding = false;
          if (this.addLabel) this.addLabel.textContent = label;
          this.setBusy('add', false);
        });
    }

    /* ---- Buy now: add the variant, then straight on to checkout ---- */
    buyNow(trigger) {
      if (!this.form || !this.buyBtn || this.buyBtn.disabled || this._buying) return;
      this._buying = true;
      this.clearError();
      this.setBusy('buy', true);
      this.postAdd()
        .then(() => {
          // keep spinning until the checkout page takes over
          window.location.assign('/checkout');
        })
        .catch((err) => {
          this._buying = false;
          this.setBusy('buy', false);
          this.showError(err && err.message);
        });
    }

    /* POST /cart/add.js with the form's fields; resolves with the line item */
    postAdd() {
      return fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'application/json' },
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error((data && (data.description || data.message)) || 'Could not add to cart.');
          return data;
        });
    }

    /* Header / dock bag badge: the add response has no count, so ask the cart */
    refreshCartCount() {
      const apply = (count) => {
        if (typeof count !== 'number') return;
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = count;
          el.hidden = count === 0;
        });
        document.querySelectorAll('.site-header__cart, .mobile-dock__bag, [data-cart-link]').forEach((el) => {
          el.setAttribute('aria-label', (count === 1 ? 'Cart (1 item)' : 'Cart (' + count + ' items)'));
        });
      };
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => apply(cart && cart.item_count))
        .catch(() => {});
    }

    /* "Size : UK 6" and the colour on their own lines */
    optionLines(item) {
      const fieldsets = Array.from(this.querySelectorAll('.pdp__option'));
      let pairs = [];
      if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
        pairs = item.options_with_values.map((o) => ({ name: String(o.name || ''), value: String(o.value || '') }));
      } else if (item.variant_title && item.variant_title !== 'Default Title') {
        pairs = String(item.variant_title)
          .split(' / ')
          .map((v, i) => ({ name: fieldsets[i] ? fieldsets[i].dataset.optionName || '' : '', value: v }));
      }
      return pairs
        .filter((p) => p.value && p.value !== 'Default Title')
        .map((p) => {
          const lower = p.name.toLowerCase();
          if (!p.name || /colou?r|shade/.test(lower)) return p.value;
          return lower.charAt(0).toUpperCase() + lower.slice(1) + ' : ' + p.value;
        });
    }

    showAdded(item, trigger) {
      if (!this.added || !this.addedDialog) return;
      const img = this.added.querySelector('[data-added-image]');
      if (img) {
        const src = item.image || (item.featured_image && item.featured_image.url) || '';
        if (src) {
          // Shopify CDN: ask for a small rendition for the 96–128px thumbnail
          img.src = /^https?:\/\//.test(src) ? src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_300x$1$2') : src;
          img.alt = item.product_title || '';
          img.hidden = false;
          img.classList.remove('is-loaded');
          const done = () => img.classList.add('is-loaded');
          img.onload = done;
          img.onerror = done;
          if (img.complete && img.naturalWidth > 0) done();
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }
      }
      const name = this.added.querySelector('[data-added-name]');
      if (name) name.textContent = item.product_title || item.title || '';
      const opts = this.added.querySelector('[data-added-options]');
      if (opts) {
        opts.textContent = '';
        this.optionLines(item).forEach((line) => {
          const span = document.createElement('span');
          span.textContent = line;
          opts.appendChild(span);
        });
      }
      const price = this.added.querySelector('[data-added-price]');
      if (price) price.innerHTML = this.formatMoney(typeof item.final_price === 'number' ? item.final_price : item.price || 0);
      const body = this.added.querySelector('.pdp-added__body');
      if (body) body.scrollTop = 0;
      this.addedDialog.open(trigger || this.addBtn);
    }

    selectedOptions() {
      const out = [];
      this.querySelectorAll('.pdp__option').forEach((fs) => {
        const checked = fs.querySelector('.pdp__swatch-input:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    refreshValueAvailability() {
      // A size is unavailable if no available variant carries it with the
      // currently selected colour. Colour itself is never restricted.
      const sel = this.selectedOptions();
      const colorFs = this.colorFieldset();
      const colorIndex = colorFs
        ? Array.from(this.querySelectorAll('.pdp__option')).indexOf(colorFs)
        : -1;
      this.querySelectorAll('.pdp__option').forEach((fs, fsIndex) => {
        fs.querySelectorAll('.pdp__swatch-input').forEach((input) => {
          const probe = sel.slice();
          probe[fsIndex] = input.value;
          // Only the colour constrains a size, so ignore other unselected axes
          const ok = this.variants.some((v) => {
            if (!v.available) return false;
            if (v.options[fsIndex] !== input.value) return false;
            if (colorIndex > -1 && colorIndex !== fsIndex) {
              const chosenColor = sel[colorIndex];
              if (chosenColor && v.options[colorIndex] !== chosenColor) return false;
            }
            return true;
          });
          const label = input.nextElementSibling;
          if (!label) return;
          // Colour swatches are never locked — a shopper can always view a colour.
          if (label.classList.contains('pdp__swatch--color')) return;
          if (label.classList.contains('pdp__swatch--pill')) {
            label.classList.toggle('is-oos', !ok);
            input.disabled = !ok;
          }
        });
      });

      // If the selected size isn't available in the newly chosen colour, move to
      // the first size that is — rather than leaving the shopper with nothing.
      this.querySelectorAll('.pdp__option').forEach((fs) => {
        if (fs === colorFs) return;
        const inputs = Array.from(fs.querySelectorAll('.pdp__swatch-input'));
        const checked = inputs.find((i) => i.checked);
        if (checked && checked.disabled) {
          checked.checked = false;
          const next = inputs.find((i) => !i.disabled);
          if (next) next.checked = true;
        }
      });
    }

    onOptionChange() {
      if (!this.variants.length) return;
      this.refreshValueAvailability();
      const sel = this.selectedOptions();
      let variant = this.variants.find((v) =>
        sel.every((val, i) => val === null || v.options[i] === val)
      );

      if (!variant) {
        // No variant for this exact combination — keep the colour selectable and
        // still show its images by matching on the colour option alone.
        const colorFs = this.colorFieldset();
        if (colorFs) {
          const colorIndex = Array.from(this.querySelectorAll('.pdp__option')).indexOf(colorFs);
          const checked = colorFs.querySelector('.pdp__swatch-input:checked');
          if (checked) {
            variant = this.variants.find((v) => v.options[colorIndex] === checked.value);
          }
        }
        this.setAvailability(false, 'Unavailable');
        this.updateGallery(variant || null);
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;
      if (this.priceEl) this.priceEl.innerHTML = this.formatMoney(variant.price);
      const onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      if (this.compareEl) {
        if (onSale) this.compareEl.innerHTML = this.formatMoney(variant.compare_at_price);
        this.compareEl.hidden = !onSale;
      }
      if (this.discountEl) {
        if (onSale) this.discountEl.textContent = Math.round((1 - variant.price / variant.compare_at_price) * 100) + '% off';
        this.discountEl.hidden = !onSale;
      }
      this.setAvailability(variant.available, variant.available ? null : 'Sold out');
      this.updateGallery(variant);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch (e) {
        /* noop */
      }
    }

    // Finds the colour fieldset by attribute, then by option name, then by
    // the presence of image swatches — so it works whatever the option is called.
    colorFieldset() {
      let fs = this.querySelector('.pdp__option[data-color-option]');
      if (fs) return fs;
      fs = Array.from(this.querySelectorAll('.pdp__option')).find((f) => {
        const n = (f.dataset.optionName || '').toLowerCase();
        return n.indexOf('color') > -1 || n.indexOf('colour') > -1 || n.indexOf('shade') > -1;
      });
      if (fs) return fs;
      const swatch = this.querySelector('.pdp__swatch--color');
      return swatch ? swatch.closest('.pdp__option') : null;
    }

    updateGallery(variant) {
      const medias = Array.from(this.querySelectorAll('.pdp__media'));
      if (!medias.length) return;

      const colorFs = this.colorFieldset();
      let visible = null;

      if (colorFs) {
        const checked = colorFs.querySelector('.pdp__swatch-input:checked');
        const color = checked ? checked.value.toLowerCase() : '';
        if (color) {
          // 1) Explicit: images whose alt text names the color
          // ("swatch: <colour>" alts only pick the swatch tile, not the gallery)
          const matches = medias.filter((m) => {
            const alt = m.dataset.alt || '';
            return alt.indexOf('swatch') === -1 && alt.indexOf(color) !== -1;
          });
          if (matches.length) {
            visible = matches;
          } else {
            // 2) Sequence grouping: a color's gallery runs from its variant
            //    image up to the image before the next color's variant image.
            //    (Works when images are uploaded grouped per color.)
            const colorIndex = Array.from(this.querySelectorAll('.pdp__option')).indexOf(colorFs);
            const starts = [];
            const seen = {};
            this.variants.forEach((v) => {
              const cval = v.options[colorIndex];
              if (cval == null || seen[cval] || !v.featured_media) return;
              const pos = medias.findIndex((m) => m.dataset.mediaId === String(v.featured_media.id));
              if (pos !== -1) {
                seen[cval] = true;
                starts.push({ color: cval.toLowerCase(), pos });
              }
            });
            starts.sort((a, b) => a.pos - b.pos);
            const idx = starts.findIndex((s) => s.color === color);
            if (idx !== -1) {
              const from = starts[idx].pos;
              const to = idx + 1 < starts.length ? starts[idx + 1].pos : medias.length;
              visible = medias.slice(from, to);
            }
          }
        }
      }

      // Fallback A: the selected variant's own image.
      if ((!visible || !visible.length) && variant && variant.featured_media) {
        const own = medias.find((m) => m.dataset.mediaId === String(variant.featured_media.id));
        if (own) visible = [own];
      }

      // Fallback B: no alt tags, no variant images — split the gallery evenly
      // between the colours, in the order the swatches appear. Works when the
      // images are simply uploaded grouped by colour.
      if ((!visible || !visible.length) && colorFs) {
        const inputs = Array.from(colorFs.querySelectorAll('.pdp__swatch-input'));
        const idx = inputs.findIndex((i) => i.checked);
        if (idx > -1 && inputs.length > 1 && medias.length >= inputs.length) {
          const per = Math.floor(medias.length / inputs.length);
          const from = idx * per;
          const to = idx === inputs.length - 1 ? medias.length : from + per;
          const slice = medias.slice(from, to);
          if (slice.length) visible = slice;
        }
      }

      // Still nothing to filter by: show everything
      if (!visible || !visible.length) visible = medias;

      medias.forEach((m) => {
        m.hidden = visible.indexOf(m) === -1;
      });

      // Jump back to the first image of the newly selected colour
      const track = this.querySelector('.pdp__gallery .carousel__track');
      if (track) track.scrollTo({ left: 0, behavior: 'auto' });
      if (this.syncGalleryNav) requestAnimationFrame(() => this.syncGalleryNav());
    }

    visibleMedia() {
      if (!this.track) return [];
      return Array.from(this.track.querySelectorAll('.pdp__media:not([hidden])'));
    }

    currentIndex() {
      const items = this.visibleMedia();
      if (!items.length || !this.track) return 0;
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let idx = 0;
      items.forEach((m, i) => {
        if (m.offsetLeft - this.track.offsetLeft <= mid) idx = i;
      });
      return idx;
    }

    slideBy(step) {
      const items = this.visibleMedia();
      if (!items.length) return;
      const next = Math.min(Math.max(this.currentIndex() + step, 0), items.length - 1);
      const target = items[next];
      this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }

    syncGalleryNav() {
      const items = this.visibleMedia();
      if (!items.length) return;
      const idx = this.currentIndex();
      if (this.prevBtn) this.prevBtn.disabled = idx === 0;
      if (this.nextBtn) this.nextBtn.disabled = idx >= items.length - 1;
      if (this.countEl) this.countEl.textContent = items.length > 1 ? idx + 1 + ' / ' + items.length : '';
      // Dots follow the visible (colour-filtered) slides: dot n ↔ media n
      if (this.dots && this.dots.length) {
        const medias = Array.from(this.track.querySelectorAll('.pdp__media'));
        let shown = 0;
        this.dots.forEach((dot, i) => {
          const media = medias[i];
          const pos = media ? items.indexOf(media) : -1;
          dot.hidden = pos === -1;
          if (pos !== -1) {
            shown += 1;
            dot.setAttribute('aria-current', pos === idx ? 'true' : 'false');
          }
        });
        if (this.dotsWrap) this.dotsWrap.hidden = shown < 2;
      }
    }

    setAvailability(available, label) {
      if (this.addBtn) {
        this.addBtn.disabled = !available;
        if (this.addLabel) this.addLabel.textContent = label || this.addLabel.dataset.default || 'Add To Bag';
      }
      if (this.buyBtn) this.buyBtn.disabled = !available;
      if (this.barAdd) {
        this.barAdd.disabled = !available;
        this.barAdd.textContent = label || (this.addLabel && this.addLabel.dataset.default) || 'Add To Bag';
      }
      if (this.barBuy) this.barBuy.disabled = !available;
    }

    formatMoney(cents) {
      const active = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (active && active !== 'INR') {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: active }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2) + ' ' + active;
        }
      }
      let value;
      try {
        value = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      } catch (e) {
        value = (cents / 100).toFixed(2);
      }
      const RUPEE =
        '<svg viewBox="0 0 9 15" fill="currentColor" aria-hidden="true" style="height:0.82em;width:auto;display:inline-block;vertical-align:-0.02em;margin-right:0.12em"><path d="M3.72 14.28L5.96046e-08 7.78003V6.72003H0.66C1.3 6.72003 1.84667 6.65336 2.3 6.52003C2.75333 6.3867 3.11333 6.17336 3.38 5.88003C3.64667 5.57336 3.81333 5.18003 3.88 4.70003H5.96046e-08V3.36003H3.86C3.76667 2.9067 3.59333 2.53336 3.34 2.24003C3.08667 1.93336 2.74667 1.7067 2.32 1.56003C1.89333 1.41336 1.38 1.34003 0.78 1.34003H5.96046e-08V2.83718e-05H8.5V1.34003H4.9C5.18 1.59336 5.41333 1.8867 5.6 2.22003C5.78667 2.55336 5.90667 2.93336 5.96 3.36003H8.5V4.70003H6C5.90667 5.67336 5.53333 6.43336 4.88 6.98003C4.24 7.5267 3.4 7.88003 2.36 8.04003L6.22 14.28H3.72Z"/></svg>';
      return RUPEE + value;
    }

    /* ---- Full-screen image viewer (desktop gallery) ----
       Opens on the tile that was clicked and steps through the images that
       are currently visible, so it follows the selected colour. */
    setupLightbox() {
      const box = this.querySelector('[data-lightbox]');
      if (!box) return;
      const img = box.querySelector('[data-lightbox-img]');
      const prev = box.querySelector('[data-lightbox-prev]');
      const next = box.querySelector('[data-lightbox-next]');
      const close = box.querySelector('[data-lightbox-close]');
      const status = box.querySelector('[data-lightbox-status]');
      const desktop = window.matchMedia('(min-width: 990px)');
      let items = [];
      let index = 0;
      let opener = null;
      let hideTimer = null;

      const collect = () =>
        Array.from(this.querySelectorAll('.pdp__media[data-zoom-src]')).filter((m) => !m.hidden);

      const show = (i) => {
        if (!items.length) return;
        index = (i + items.length) % items.length;
        const media = items[index];
        const ratio = parseFloat(media.dataset.zoomRatio) || 0.8;
        const thumb = media.querySelector('img');
        img.width = 1000;
        img.height = Math.round(1000 / ratio);
        img.src = media.dataset.zoomSrc;
        img.alt = thumb ? thumb.alt : '';
        const many = items.length > 1;
        prev.hidden = !many;
        next.hidden = !many;
        if (status) status.textContent = 'Image ' + (index + 1) + ' of ' + items.length;
        // Warm the cache for the neighbours so stepping feels instant
        [index + 1, index - 1].forEach((n) => {
          const m = items[(n + items.length) % items.length];
          if (m && m !== media) new Image().src = m.dataset.zoomSrc;
        });
      };

      const open = (media) => {
        items = collect();
        const start = Math.max(0, items.indexOf(media));
        opener = media.querySelector('[data-lightbox-open]');
        // Sit just below the header when it is showing, as in the design
        const header = document.querySelector('sticky-header');
        const bottom = header ? header.getBoundingClientRect().bottom : 0;
        box.style.setProperty('--lightbox-top', Math.max(0, Math.round(bottom)) + 'px');
        clearTimeout(hideTimer);
        box.hidden = false;
        show(start);
        document.body.classList.add('pdp-lightbox-open');
        requestAnimationFrame(() => box.classList.add('is-open'));
        close.focus();
      };

      const shut = () => {
        if (box.hidden) return;
        box.classList.remove('is-open');
        document.body.classList.remove('pdp-lightbox-open');
        hideTimer = setTimeout(() => {
          box.hidden = true;
          img.removeAttribute('src');
        }, 260);
        if (opener) opener.focus();
      };

      this.querySelectorAll('[data-lightbox-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!desktop.matches) return;
          const media = btn.closest('.pdp__media');
          if (media) open(media);
        });
      });
      prev.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      close.addEventListener('click', shut);
      // A click on the white space around the image closes, like the design's X
      box.querySelector('.pdp-lightbox__stage').addEventListener('click', (e) => {
        if (e.target === e.currentTarget) shut();
      });

      box.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          shut();
        } else if (e.key === 'ArrowLeft') {
          show(index - 1);
        } else if (e.key === 'ArrowRight') {
          show(index + 1);
        } else if (e.key === 'Tab') {
          // Keep focus inside the dialog
          const f = [close, prev, next].filter((b) => !b.hidden);
          const i = f.indexOf(document.activeElement);
          e.preventDefault();
          const n = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i === f.length - 1 ? 0 : i + 1);
          f[n].focus();
        }
      });

      // Resizing down to tablet/mobile closes the viewer (it is desktop-only)
      desktop.addEventListener('change', (e) => {
        if (!e.matches) shut();
      });
    }

    /* ---- Size chart dialog ---- */
    setupSizeChart() {
      const modal = this.querySelector('.sizechart');
      const openers = this.querySelectorAll('[data-sizechart-open]');
      if (!modal || !openers.length) return;

      const setOpen = (open) => {
        modal.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.classList.toggle('sizechart-open', open);
        openers.forEach((b) => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
        if (open) {
          this.markSizeChartRow();
          const body = modal.querySelector('.sizechart__body');
          if (body) body.scrollTop = 0;
          const close = modal.querySelector('.sizechart__close');
          // wait a frame: the dialog is still visibility:hidden as it starts to fade in
          if (close) setTimeout(() => close.focus(), 60);
        } else if (openers[0]) {
          openers[0].focus();
        }
      };

      openers.forEach((btn) => btn.addEventListener('click', () => setOpen(true)));
      modal.querySelectorAll('[data-sizechart-close]').forEach((el) =>
        el.addEventListener('click', () => setOpen(false))
      );
      document.addEventListener('keydown', (e) => {
        if (modal.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') {
          setOpen(false);
          return;
        }
        // keep Tab inside the open dialog
        if (e.key !== 'Tab') return;
        const items = [...modal.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')].filter(
          (el) => el.offsetParent !== null
        );
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (!modal.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    /* Highlights the row for the size the shopper has selected, so the chart
       opens on the number they are already looking at. */
    markSizeChartRow() {
      const modal = this.querySelector('.sizechart');
      if (!modal) return;
      let selected = '';
      this.querySelectorAll('.pdp__option').forEach((fs) => {
        const name = fs.getAttribute('data-option-name') || '';
        if (name.indexOf('size') === -1) return;
        const checked = fs.querySelector('input:checked');
        if (checked) selected = (checked.value || '').trim().toLowerCase();
      });
      modal.querySelectorAll('tbody tr').forEach((tr) => {
        const value = (tr.getAttribute('data-size') || '').trim().toLowerCase();
        tr.classList.toggle('is-current', !!selected && value === selected);
      });
    }
  }

  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      // Server render already provided cards when recommendations were available
      if (!this.hasAttribute('data-related-pending')) return;
      const url = this.dataset.url;
      const grid = this.querySelector('[data-related-grid]');
      if (!url || !grid) return;
      const limit = Math.min(parseInt(this.dataset.limit || '4', 10) || 4, 8);
      if (window.Jogger && window.Jogger.skeletonCards) {
        window.Jogger.showSkeleton(grid, window.Jogger.skeletonCards(Math.min(limit, 4)));
      }
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-related-grid]');
          const hasCards = fresh && fresh.querySelector('.product-card');
          if (hasCards) {
            if (window.Jogger && window.Jogger.clearSkeleton) window.Jogger.clearSkeleton(grid, fresh.innerHTML);
            else grid.innerHTML = fresh.innerHTML;
            grid.removeAttribute('aria-busy');
            this.removeAttribute('data-related-pending');
          } else {
            // nothing to recommend: leave no empty heading or gap behind
            this.hidden = true;
          }
        })
        .catch(() => {
          this.hidden = true;
        });
    }
  }
  if (!customElements.get('related-products')) customElements.define('related-products', RelatedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /* A new search is a full page load. While it is in flight the button shows
     its spinner and the current results give way to skeleton cards, so the
     page reads as "loading" rather than stale. */
  class SearchPage extends HTMLElement {
    connectedCallback() {
      var host = this;
      this.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('[data-search-form]')) return;
        var field = form.querySelector('input[name="q"]');
        if (!field || field.value.trim() === '') return;
        var btn = form.querySelector('[data-search-submit]');
        if (btn) btn.classList.add('is-loading');
        var grid = host.querySelector('[data-search-grid]');
        var J = window.Jogger;
        if (grid && J && J.showSkeleton && J.skeletonCards) {
          J.showSkeleton(grid, J.skeletonCards(8));
        }
      });
      // Back/forward cache: never leave the spinner on
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        var busy = host.querySelectorAll('.is-loading');
        for (var i = 0; i < busy.length; i++) busy[i].classList.remove('is-loading');
      });
    }
  }
  if (!customElements.get('search-page')) customElements.define('search-page', SearchPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  class VideoGallery extends HTMLElement {
    connectedCallback() {
      // ---- Uploaded videos: make sure sources are attached before the shared
      //      [data-video-play] handler in jogger.js calls play() (a tap can land
      //      before the lazy-load observer has fired). Capture phase = runs first.
      this.addEventListener(
        'click',
        (e) => {
          const play = e.target.closest('[data-video-play]');
          if (!play) return;
          const card = play.closest('[data-video-card]');
          const video = card && card.querySelector('video');
          if (!video) return;
          const pending = video.querySelectorAll('source[data-src]');
          if (!pending.length) return;
          pending.forEach((s) => {
            s.src = s.dataset.src;
            s.removeAttribute('data-src');
          });
          video.dataset.lazyLoaded = '1';
          video.load();
        },
        true
      );

      // ---- YouTube / Vimeo links: swap poster for an embed on play ----
      this.querySelectorAll('[data-embed-play]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = btn.closest('[data-video-card]');
          const media = btn.closest('.video-gallery__media');
          if (!media) return;
          const type = btn.dataset.embedType;
          const id = btn.dataset.embedId;
          let src = '';
          if (type === 'youtube') {
            src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&mute=1&playsinline=1&loop=1&playlist=' + id + '&enablejsapi=1';
          } else if (type === 'vimeo') {
            src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1&loop=1';
          }
          if (!src) return;
          const iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('allowfullscreen', '');
          iframe.title = 'Video';
          // Keep the poster underneath and dim it until the player has loaded
          btn.remove();
          media.classList.add('is-busy');
          iframe.addEventListener('load', () => media.classList.remove('is-busy'), { once: true });
          media.appendChild(iframe);
          if (card) card.classList.add('is-playing');
        });
      });

      // ---- Pause anything playing once its card leaves the viewport ----
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) return;
              const card = entry.target;
              const video = card.querySelector('video');
              if (video && !video.paused) {
                video.pause();
                card.classList.remove('is-playing');
              }
              const iframe = card.querySelector('iframe');
              if (iframe && iframe.contentWindow) {
                if (iframe.src.indexOf('youtube') !== -1) {
                  iframe.contentWindow.postMessage(
                    JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
                    '*'
                  );
                } else if (iframe.src.indexOf('vimeo') !== -1) {
                  iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
                }
                card.classList.remove('is-playing');
              }
            });
          },
          { threshold: 0.25 }
        );
        this.querySelectorAll('[data-video-card]').forEach((card) => io.observe(card));
      }
    }
  }
  if (!customElements.get('video-gallery')) customElements.define('video-gallery', VideoGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  class WishlistPage extends HTMLElement {
    /* The heading carries the number, as the design shows. Saved items live
       in the browser, so Liquid cannot know the count and the script sets it
       once the list has been read. */
    setCount(n) {
      var count = this.querySelector('[data-wishlist-count]');
      var word = this.querySelector('[data-wishlist-word]');
      if (count) count.textContent = n;
      if (word) word.textContent = n === 1 ? 'Item' : 'Items';
    }

    connectedCallback() {
      this.KEY = 'jogger:wishlist';
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.emptyEl = this.querySelector('[data-wishlist-empty]');
      this.tpl = this.querySelector('template[data-wishlist-card]');
      // One delegated handler survives re-renders and beats any bubbling issues
      this.grid.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-w-remove]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.wRemove;
        try {
          const next = this.list().filter((h) => h !== handle);
          localStorage.setItem(this.KEY, JSON.stringify(next));
        } catch (err) {}
        const card = btn.closest('.wishlist__card');
        if (card) card.remove();
        const left = this.grid.querySelectorAll('.wishlist__card').length;
        this.setCount(left);
        if (!left) this.showEmpty();
      });

      this.RUPEE =
        '<svg viewBox="0 0 9 15" fill="currentColor" aria-hidden="true" style="height:0.82em;width:auto;display:inline-block;vertical-align:-0.02em;margin-right:0.12em"><path d="M3.72 14.28L5.96046e-08 7.78003V6.72003H0.66C1.3 6.72003 1.84667 6.65336 2.3 6.52003C2.75333 6.3867 3.11333 6.17336 3.38 5.88003C3.64667 5.57336 3.81333 5.18003 3.88 4.70003H5.96046e-08V3.36003H3.86C3.76667 2.9067 3.59333 2.53336 3.34 2.24003C3.08667 1.93336 2.74667 1.7067 2.32 1.56003C1.89333 1.41336 1.38 1.34003 0.78 1.34003H5.96046e-08V2.83718e-05H8.5V1.34003H4.9C5.18 1.59336 5.41333 1.8867 5.6 2.22003C5.78667 2.55336 5.90667 2.93336 5.96 3.36003H8.5V4.70003H6C5.90667 5.67336 5.53333 6.43336 4.88 6.98003C4.24 7.5267 3.4 7.88003 2.36 8.04003L6.22 14.28H3.72Z"/></svg>';
      this.render();
    }

    list() {
      try {
        return JSON.parse(localStorage.getItem(this.KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    money(cents) {
      const active = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (active && active !== 'INR') {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: active }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2) + ' ' + active;
        }
      }
      let value;
      try {
        value = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      } catch (e) {
        value = (cents / 100).toFixed(2);
      }
      return this.RUPEE + value;
    }

    showEmpty() {
      this.grid.hidden = true;
      this.emptyEl.hidden = false;
      this.setCount(0);
      if (window.Jogger && Jogger.observeLazy) Jogger.observeLazy(this.emptyEl);
    }

    skeleton(n) {
      if (window.Jogger && Jogger.skeletonCards) return Jogger.skeletonCards(n);
      let out = '';
      for (let i = 0; i < n; i++) {
        out += '<div class="skeleton-card" aria-hidden="true"><div class="skeleton skeleton--media"></div><div class="skeleton skeleton--text"></div><div class="skeleton skeleton--text is-short"></div></div>';
      }
      return out;
    }

    render() {
      const handles = this.list();
      if (!handles.length) {
        this.showEmpty();
        return;
      }
      this.grid.hidden = false;
      this.emptyEl.hidden = true;
      const skeletonHtml = this.skeleton(Math.min(Math.max(handles.length, 2), 8));
      if (window.Jogger && Jogger.showSkeleton) Jogger.showSkeleton(this.grid, skeletonHtml);
      else this.grid.innerHTML = skeletonHtml;

      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(
        handles.map((h) =>
          fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      ).then((products) => {
        const frag = document.createDocumentFragment();
        let shown = 0;
        products.forEach((p) => {
          if (!p || !p.handle) return; // failed/unpublished: skip quietly
          shown += 1;
          const node = this.tpl.content.cloneNode(true);
          node.querySelectorAll('[data-w-link]').forEach((a) => (a.href = p.url));
          const sized = (u) => u.replace(/(\.[a-z]{3,4})(\?|$)/, '_600x$1$2');
          const img = node.querySelector('[data-w-image]');
          if (p.featured_image) {
            img.src = sized(p.featured_image);
            img.alt = p.title;
          } else {
            img.remove();
          }
          // second photo on hover, like every other product card
          const hover = node.querySelector('[data-w-hover]');
          const second = (p.images || []).find((u) => u && u !== p.featured_image);
          if (hover) {
            if (second) {
              hover.src = sized(second);
              hover.hidden = false;
            } else {
              hover.remove();
            }
          }
          // badges: Best Selling (tag) + offer (compare-at price)
          const tags = (p.tags || []).join(',').toLowerCase().replace(/[-_]/g, ' ');
          const isBest = tags.indexOf('best sell') > -1 || tags.indexOf('bestsell') > -1;
          const isSale = !!(p.compare_at_price && p.compare_at_price > p.price);
          const badges = node.querySelector('[data-w-badges]');
          if (badges) {
            // one badge only: Best Selling wins over the offer badge
            if (isBest) badges.querySelector('[data-w-badge-best]').hidden = false;
            else if (isSale) badges.querySelector('[data-w-badge-sale]').hidden = false;
            if (isBest || isSale) badges.hidden = false;
            else badges.remove();
          }
          node.querySelector('[data-w-title]').textContent = p.title;
          node.querySelector('[data-w-price]').innerHTML = this.money(p.price);
          const cmp = node.querySelector('[data-w-compare]');
          if (p.compare_at_price && p.compare_at_price > p.price) {
            cmp.innerHTML = this.money(p.compare_at_price);
            cmp.hidden = false;
          }
          const remove = node.querySelector('[data-w-remove]');
          remove.dataset.wRemove = p.handle;
          remove.setAttribute('aria-label', 'Remove ' + p.title + ' from wishlist');
          frag.appendChild(node);
        });

        if (window.Jogger && Jogger.clearSkeleton) {
          Jogger.clearSkeleton(this.grid, '');
        } else {
          this.grid.innerHTML = '';
        }
        this.grid.appendChild(frag);
        if (window.Jogger && Jogger.prepImages) Jogger.prepImages(this.grid);

        if (shown === 0) {
          this.showEmpty();
        } else {
          this.grid.hidden = false;
          this.emptyEl.hidden = true;
          this.setCount(shown);
        }
      });
    }
  }
  if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);

  } catch(e) { console.error(e); }
})();
})();
